import icon0 from './complementary--accident-area--g1.png';
import icon1 from './complementary--accident-area--g2.png';
import icon2 from './complementary--accident-area--g3.png';
import icon3 from './complementary--accident-area--g4.png';
import icon4 from './complementary--advisory-exit-or-ramp-speed--g1.png';
import icon5 from './complementary--bicycles--g1.png';
import icon6 from './complementary--bicycles-and-pedestrians-detour--g1.png';
import icon7 from './complementary--bicycles-or-pedestrians-detour--g1.png';
import icon8 from './complementary--bicycles-turn-right--g1.png';
import icon9 from './complementary--bike-route--g1.png';
import icon10 from './complementary--bike-route--g3.png';
import icon11 from './complementary--both-directions--g1.png';
import icon12 from './complementary--both-directions--g2.png';
import icon13 from './complementary--buses--g1.png';
import icon14 from './complementary--buses-and-trucks--g1.png';
import icon15 from './complementary--camera--g1.png';
import icon16 from './complementary--camera--g2.png';
import icon17 from './complementary--camera--g3.png';
import icon18 from './complementary--camera--g4.png';
import icon19 from './complementary--camera--g5.png';
import icon20 from './complementary--caravan-trailers--g2.png';
import icon21 from './complementary--caravan-trailers--g3.png';
import icon22 from './complementary--caravans--g2.png';
import icon23 from './complementary--carts--g1.png';
import icon24 from './complementary--chevron-left--g1.png';
import icon25 from './complementary--chevron-left--g2.png';
import icon26 from './complementary--chevron-left--g3.png';
import icon27 from './complementary--chevron-left--g4.png';
import icon28 from './complementary--chevron-left--g5.png';
import icon29 from './complementary--chevron-right--g1.png';
import icon30 from './complementary--chevron-right--g2.png';
import icon31 from './complementary--chevron-right--g3.png';
import icon32 from './complementary--chevron-right--g4.png';
import icon33 from './complementary--chevron-right--g5.png';
import icon34 from './complementary--dangerous-or-pollutant-good--g1.png';
import icon35 from './complementary--dead-end--g1.png';
import icon36 from './complementary--detour--g1.png';
import icon37 from './complementary--disabled-persons--g1.png';
import icon38 from './complementary--distance--g1.png';
import icon39 from './complementary--distance--g2.png';
import icon40 from './complementary--distance--g3.png';
import icon41 from './complementary--end-of-road-works--g1.png';
import icon42 from './complementary--except-bicycles--g1.png';
import icon43 from './complementary--except-bicycles--g2.png';
import icon44 from './complementary--except-buses--g1.png';
import icon45 from './complementary--except-carts--g1.png';
import icon46 from './complementary--except-motorcycles--g1.png';
import icon47 from './complementary--except-motorcycles--g2.png';
import icon48 from './complementary--except-polluting-level-green--g1.png';
import icon49 from './complementary--except-polluting-level-green-yellow--g1.png';
import icon50 from './complementary--except-polluting-level-green-yellow-red--g1.png';
import icon51 from './complementary--except-tractors--g1.png';
import icon52 from './complementary--except-tractors--g2.png';
import icon53 from './complementary--except-trailers--g1.png';
import icon54 from './complementary--except-trailers--g2.png';
import icon55 from './complementary--except-trains--g1.png';
import icon56 from './complementary--except-trams--g1.png';
import icon57 from './complementary--except-trucks--g1.png';
import icon58 from './complementary--except-vehicles--g1.png';
import icon59 from './complementary--except-vehicles--g2.png';
import icon60 from './complementary--go-left--g1.png';
import icon61 from './complementary--go-right--g1.png';
import icon62 from './complementary--go-straight-or-turn-left--g1.png';
import icon63 from './complementary--go-straight-or-turn-right--g1.png';
import icon64 from './complementary--height-limit--g1.png';
import icon65 from './complementary--height-limit--g2.png';
import icon66 from './complementary--including-bicycles-and-motorcycles--g1.png';
import icon67 from './complementary--including-buses-vehicles--g1.png';
import icon68 from './complementary--keep-left--g1.png';
import icon69 from './complementary--keep-right--g1.png';
import icon70 from './complementary--lane-control--g1.png';
import icon71 from './complementary--lane-control--g2.png';
import icon72 from './complementary--lane-control--g3.png';
import icon73 from './complementary--maximum-speed-limit-10--g1.png';
import icon74 from './complementary--maximum-speed-limit-15--g1.png';
import icon75 from './complementary--maximum-speed-limit-20--g1.png';
import icon76 from './complementary--maximum-speed-limit-25--g1.png';
import icon77 from './complementary--maximum-speed-limit-30--g1.png';
import icon78 from './complementary--maximum-speed-limit-35--g1.png';
import icon79 from './complementary--maximum-speed-limit-40--g1.png';
import icon80 from './complementary--maximum-speed-limit-45--g1.png';
import icon81 from './complementary--maximum-speed-limit-50--g1.png';
import icon82 from './complementary--maximum-speed-limit-55--g1.png';
import icon83 from './complementary--maximum-speed-limit-60--g1.png';
import icon84 from './complementary--maximum-speed-limit-65--g1.png';
import icon85 from './complementary--maximum-speed-limit-70--g1.png';
import icon86 from './complementary--maximum-speed-limit-75--g1.png';
import icon87 from './complementary--maximum-speed-limit-80--g1.png';
import icon88 from './complementary--maximum-speed-limit-85--g1.png';
import icon89 from './complementary--maximum-speed-limit-90--g1.png';
import icon90 from './complementary--maximum-speed-limit-95--g1.png';
import icon91 from './complementary--motorcycles--g1.png';
import icon92 from './complementary--motorcycles--g2.png';
import icon93 from './complementary--motorcycles--g3.png';
import icon94 from './complementary--motorcycles--g4.png';
import icon95 from './complementary--obstacle-delineator--g1.png';
import icon96 from './complementary--obstacle-delineator--g2.png';
import icon97 from './complementary--obstacle-delineator--g3.png';
import icon98 from './complementary--one-direction-left--g1.png';
import icon99 from './complementary--one-direction-right--g1.png';
import icon100 from './complementary--pass-left--g1.png';
import icon101 from './complementary--pass-right--g1.png';
import icon102 from './complementary--pedestrians-and-bicycles--g1.png';
import icon103 from './complementary--pedestrians-left--g1.png';
import icon104 from './complementary--pedestrians-right--g1.png';
import icon105 from './complementary--photo-enforced--g1.png';
import icon106 from './complementary--playground--g1.png';
import icon107 from './complementary--priority-route-at-intersection--g1.png';
import icon108 from './complementary--priority-route-at-intersection--g2.png';
import icon109 from './complementary--priority-route-at-intersection--g3.png';
import icon110 from './complementary--priority-route-at-intersection--g4.png';
import icon111 from './complementary--priority-route-at-intersection--g5.png';
import icon112 from './complementary--priority-route-at-intersection--g6.png';
import icon113 from './complementary--railroad--g1.png';
import icon114 from './complementary--railroad--g2.png';
import icon115 from './complementary--railroad--g3.png';
import icon116 from './complementary--restriction-in-both-directions--g1.png';
import icon117 from './complementary--roundabout-go-left--g1.png';
import icon118 from './complementary--roundabout-go-right--g1.png';
import icon119 from './complementary--roundabout-go-straight--g1.png';
import icon120 from './complementary--slippery-for-caravan-trailers--g1.png';
import icon121 from './complementary--snow--g2.png';
import icon122 from './complementary--snow--g4.png';
import icon123 from './complementary--snow--g5.png';
import icon124 from './complementary--snowmobiles--g1.png';
import icon125 from './complementary--soft-shoulder--g1.png';
import icon126 from './complementary--soft-shoulder--g2.png';
import icon127 from './complementary--steep-ascent--g1.png';
import icon128 from './complementary--steep-descent--g1.png';
import icon129 from './complementary--time-restrictions--g1.png';
import icon130 from './complementary--time-restrictions--g3.png';
import icon131 from './complementary--tow-away-zone--g1.png';
import icon132 from './complementary--tow-away-zone--g3.png';
import icon133 from './complementary--tractors--g1.png';
import icon134 from './complementary--traffic-queues--g1.png';
import icon135 from './complementary--trailers--g1.png';
import icon136 from './complementary--trailers--g2.png';
import icon137 from './complementary--trailers--g3.png';
import icon138 from './complementary--trailers--g4.png';
import icon139 from './complementary--trains--g1.png';
import icon140 from './complementary--trams--g1.png';
import icon141 from './complementary--trees--g1.png';
import icon142 from './complementary--trucks--g1.png';
import icon143 from './complementary--trucks--g2.png';
import icon144 from './complementary--trucks--g3.png';
import icon145 from './complementary--trucks-and-trailers--g1.png';
import icon146 from './complementary--trucks-buses-trailers--g1.png';
import icon147 from './complementary--trucks-go-left--g1.png';
import icon148 from './complementary--trucks-go-left-ahead--g1.png';
import icon149 from './complementary--trucks-go-right--g1.png';
import icon150 from './complementary--trucks-go-right-ahead--g1.png';
import icon151 from './complementary--trucks-go-straight--g1.png';
import icon152 from './complementary--trucks-turn-left--g1.png';
import icon153 from './complementary--trucks-turn-right--g1.png';
import icon154 from './complementary--turn-left--g1.png';
import icon155 from './complementary--turn-left--g2.png';
import icon156 from './complementary--turn-right--g1.png';
import icon157 from './complementary--turn-right--g2.png';
import icon158 from './complementary--two-way-traffic--g1.png';
import icon159 from './complementary--two-way-traffic--g2.png';
import icon160 from './complementary--two-way-traffic--g3.png';
import icon161 from './complementary--two-way-traffic--g4.png';
import icon162 from './complementary--two-way-traffic--g5.png';
import icon163 from './complementary--vehicles--g1.png';
import icon164 from './complementary--vehicles--g2.png';
import icon165 from './complementary--vehicles-or-buses--g1.png';
import icon166 from './complementary--weekends-or-holidays--g1.png';
import icon167 from './complementary--weight-limit--g1.png';
import icon168 from './complementary--when-foggy--g1.png';
import icon169 from './complementary--when-rainy--g1.png';
import icon170 from './complementary--when-rainy--g2.png';
import icon171 from './complementary--when-rainy--g3.png';
import icon172 from './complementary--when-snowy--g1.png';
import icon173 from './complementary--when-snowy--g2.png';
import icon174 from './complementary--when-snowy-or-rainy--g1.png';
import icon175 from './complementary--when-snowy-or-rainy--g2.png';
import icon176 from './complementary--when-wet--g1.png';
import icon177 from './complementary--width-limit--g1.png';
import icon178 from './complementary--working-days--g1.png';
import icon179 from './information--airport--g1.png';
import icon180 from './information--airport--g2.png';
import icon181 from './information--bicycle-lane--g1.png';
import icon182 from './information--bicycles-both-ways--g1.png';
import icon183 from './information--bicycles-crossing--g1.png';
import icon184 from './information--bicycles-crossing--g2.png';
import icon185 from './information--bicycles-crossing--g3.png';
import icon186 from './information--bike-route--g1.png';
import icon187 from './information--bike-route--g2.png';
import icon188 from './information--built-up-area--g1.png';
import icon189 from './information--built-up-area--g2.png';
import icon190 from './information--bus-lane-straight--g1.png';
import icon191 from './information--bus-stop--g1.png';
import icon192 from './information--bus-stop--g2.png';
import icon193 from './information--camera--g1.png';
import icon194 from './information--camera--g2.png';
import icon195 from './information--camera--g3.png';
import icon196 from './information--camp--g1.png';
import icon197 from './information--camp--g2.png';
import icon198 from './information--car-pool-lane--g1.png';
import icon199 from './information--caravan-parking--g1.png';
import icon200 from './information--caravan-trailer-parking--g1.png';
import icon201 from './information--cargo-loading-zone--g1.png';
import icon202 from './information--central-lane--g1.png';
import icon203 from './information--charging-station--g1.png';
import icon204 from './information--children--g1.png';
import icon205 from './information--children--g2.png';
import icon206 from './information--children-crossing--g5.png';
import icon207 from './information--cycling-two-abreast-permitted--g1.png';
import icon208 from './information--dead-end--g1.png';
import icon209 from './information--dead-end--g2.png';
import icon210 from './information--dead-end--g3.png';
import icon211 from './information--dead-end--g4.png';
import icon212 from './information--dead-end-except-bicycles--g1.png';
import icon213 from './information--dead-end-except-bicycles-and-pedestrians--g1.png';
import icon214 from './information--dead-end-except-bicycles-and-pedestrians--g2.png';
import icon215 from './information--dead-end-left--g1.png';
import icon216 from './information--dead-end-left--g2.png';
import icon217 from './information--dead-end-right--g1.png';
import icon218 from './information--dead-end-right--g2.png';
import icon219 from './information--dead-end-right--g3.png';
import icon220 from './information--directions--g1.png';
import icon221 from './information--disabled-persons--g1.png';
import icon222 from './information--disabled-persons--g2.png';
import icon223 from './information--disabled-persons--g3.png';
import icon224 from './information--emergency-facility--g1.png';
import icon225 from './information--end-of-advisory-maximum-speed-limit-20--g1.png';
import icon226 from './information--end-of-advisory-maximum-speed-limit-40--g1.png';
import icon227 from './information--end-of-advisory-maximum-speed-limit-60--g1.png';
import icon228 from './information--end-of-advisory-maximum-speed-limit-70--g1.png';
import icon229 from './information--end-of-advisory-maximum-speed-limit-80--g1.png';
import icon230 from './information--end-of-advisory-maximum-speed-limit-90--g1.png';
import icon231 from './information--end-of-bicycle-lane--g1.png';
import icon232 from './information--end-of-built-up-area--g1.png';
import icon233 from './information--end-of-built-up-area--g2.png';
import icon234 from './information--end-of-built-up-area--g3.png';
import icon235 from './information--end-of-built-up-area--g4.png';
import icon236 from './information--end-of-car-pool-lane--g1.png';
import icon237 from './information--end-of-limited-access-road--g1.png';
import icon238 from './information--end-of-living-street--g1.png';
import icon239 from './information--end-of-living-street--g2.png';
import icon240 from './information--end-of-minimum-speed-10--g1.png';
import icon241 from './information--end-of-minimum-speed-20--g1.png';
import icon242 from './information--end-of-minimum-speed-25--g1.png';
import icon243 from './information--end-of-minimum-speed-30--g1.png';
import icon244 from './information--end-of-minimum-speed-35--g1.png';
import icon245 from './information--end-of-minimum-speed-40--g1.png';
import icon246 from './information--end-of-minimum-speed-50--g1.png';
import icon247 from './information--end-of-minimum-speed-60--g1.png';
import icon248 from './information--end-of-minimum-speed-70--g1.png';
import icon249 from './information--end-of-minimum-speed-75--g1.png';
import icon250 from './information--end-of-minimum-speed-80--g1.png';
import icon251 from './information--end-of-minimum-speed-90--g1.png';
import icon252 from './information--end-of-minimum-speed-100--g1.png';
import icon253 from './information--end-of-minimum-speed-110--g1.png';
import icon254 from './information--end-of-minimum-speed-120--g1.png';
import icon255 from './information--end-of-minimum-speed-130--g1.png';
import icon256 from './information--end-of-motorway--g1.png';
import icon257 from './information--end-of-overtaking-permitted-heavy-good-vehicles--g1.png';
import icon258 from './information--end-of-road-works--g1.png';
import icon259 from './information--end-of-tunnel--g1.png';
import icon260 from './information--end-of-tunnel--g2.png';
import icon261 from './information--end-of-two-way-traffic--g1.png';
import icon262 from './information--equestrians-permitted--g1.png';
import icon263 from './information--exit-ahead--g1.png';
import icon264 from './information--exit-ahead--g2.png';
import icon265 from './information--exit-ahead--g3.png';
import icon266 from './information--flight-port--g1.png';
import icon267 from './information--food--g1.png';
import icon268 from './information--food--g2.png';
import icon269 from './information--gas-station--g1.png';
import icon270 from './information--gas-station--g2.png';
import icon271 from './information--gas-station--g3.png';
import icon272 from './information--general-speed-limit-at-city-border--g1.png';
import icon273 from './information--go-left--g1.png';
import icon274 from './information--go-right--g1.png';
import icon275 from './information--go-straight--g1.png';
import icon276 from './information--go-straight-or-left--g1.png';
import icon277 from './information--go-straight-or-right--g1.png';
import icon278 from './information--go-straight-or-turn-left--g1.png';
import icon279 from './information--go-straight-or-turn-right--g1.png';
import icon280 from './information--hazardous-goods-vehicles-lane--g1.png';
import icon281 from './information--height-limit--g1.png';
import icon282 from './information--height-limit--g2.png';
import icon283 from './information--highway-directions--g1.png';
import icon284 from './information--highway-exit--g1.png';
import icon285 from './information--highway-interchange--g1.png';
import icon286 from './information--highway-interstate-route--g1.png';
import icon287 from './information--highway-interstate-route--g2.png';
import icon288 from './information--highway-preferential-lane--g1.png';
import icon289 from './information--highway-preferential-lane--g2.png';
import icon290 from './information--highway-reference-location--g1.png';
import icon291 from './information--highway-reference-location--g2.png';
import icon292 from './information--hiking--g1.png';
import icon293 from './information--hospital--g1.png';
import icon294 from './information--hurricane-evacuation-route--g1.png';
import icon295 from './information--interstate-route--g1.png';
import icon296 from './information--lane-control-intersections--g1.png';
import icon297 from './information--lane-control-left-turn--g1.png';
import icon298 from './information--lane-control-multiple-lanes--g1.png';
import icon299 from './information--lane-control-multiple-lanes--g2.png';
import icon300 from './information--lane-control-right-turn--g1.png';
import icon301 from './information--limited-access-road--g1.png';
import icon302 from './information--litter-container--g1.png';
import icon303 from './information--living-street--g1.png';
import icon304 from './information--living-street--g2.png';
import icon305 from './information--living-street--g3.png';
import icon306 from './information--lodging--g1.png';
import icon307 from './information--lodging--g2.png';
import icon308 from './information--minimum-speed-10--g1.png';
import icon309 from './information--minimum-speed-20--g1.png';
import icon310 from './information--minimum-speed-25--g1.png';
import icon311 from './information--minimum-speed-30--g1.png';
import icon312 from './information--minimum-speed-35--g1.png';
import icon313 from './information--minimum-speed-40--g1.png';
import icon314 from './information--minimum-speed-50--g1.png';
import icon315 from './information--minimum-speed-60--g1.png';
import icon316 from './information--minimum-speed-70--g1.png';
import icon317 from './information--minimum-speed-75--g1.png';
import icon318 from './information--minimum-speed-80--g1.png';
import icon319 from './information--minimum-speed-90--g1.png';
import icon320 from './information--minimum-speed-100--g1.png';
import icon321 from './information--minimum-speed-110--g1.png';
import icon322 from './information--minimum-speed-120--g1.png';
import icon323 from './information--minimum-speed-130--g1.png';
import icon324 from './information--motorway--g1.png';
import icon325 from './information--motorway-exit-ahead--g1.png';
import icon326 from './information--motorway-exit-ahead--g2.png';
import icon327 from './information--motorway-exit-ahead--g3.png';
import icon328 from './information--overtaking-allowed-heavy-good-vehicles--g1.png';
import icon329 from './information--parallel-parking--g1.png';
import icon330 from './information--park-and-ride--g1.png';
import icon331 from './information--park-and-ride--g2.png';
import icon332 from './information--parking--g1.png';
import icon333 from './information--parking--g2.png';
import icon334 from './information--parking--g3.png';
import icon335 from './information--parking--g4.png';
import icon336 from './information--parking--g5.png';
import icon337 from './information--parking--g6.png';
import icon338 from './information--parking-area--g1.png';
import icon339 from './information--parking-with-restrictions--g1.png';
import icon340 from './information--pass-on-either-side--g1.png';
import icon341 from './information--passenger-loading-zone--g1.png';
import icon342 from './information--pedestrians-crossing--g1.png';
import icon343 from './information--pedestrians-crossing--g2.png';
import icon344 from './information--pedestrians-crossing--g3.png';
import icon345 from './information--pedestrians-only--g4.png';
import icon346 from './information--pedestrians-permitted--g1.png';
import icon347 from './information--perpendicular-parking--g1.png';
import icon348 from './information--picnic-site--g1.png';
import icon349 from './information--playground--g1.png';
import icon350 from './information--recreational-vehicle-sanitary-station--g1.png';
import icon351 from './information--recycle-collection-center--g1.png';
import icon352 from './information--rest-area--g1.png';
import icon353 from './information--road-bump--g1.png';
import icon354 from './information--road-skating--g1.png';
import icon355 from './information--safety-zone--g1.png';
import icon356 from './information--safety-zone--g2.png';
import icon357 from './information--safety-zone--g3.png';
import icon358 from './information--shared-path-vehicles-and-motorcycles--g1.png';
import icon359 from './information--stairs--g1.png';
import icon360 from './information--stairs--g2.png';
import icon361 from './information--stairs--g3.png';
import icon362 from './information--stairs--g4.png';
import icon363 from './information--stop-line--g1.png';
import icon364 from './information--stop-permitted--g1.png';
import icon365 from './information--street-name-one-line--g1.png';
import icon366 from './information--street-name-three-lines--g1.png';
import icon367 from './information--street-name-two-lines--g1.png';
import icon368 from './information--subway--g1.png';
import icon369 from './information--telephone--g1.png';
import icon370 from './information--telephone--g2.png';
import icon371 from './information--telephone-device-for-the-deaf--g1.png';
import icon372 from './information--toll-station--g1.png';
import icon373 from './information--tourism-information--g1.png';
import icon374 from './information--tourist-attraction--g1.png';
import icon375 from './information--traffic-merges-left--g1.png';
import icon376 from './information--traffic-merges-right--g1.png';
import icon377 from './information--trail-crossing--g1.png';
import icon378 from './information--trail-crossing--g2.png';
import icon379 from './information--trail-crossing--g3.png';
import icon380 from './information--trailer-camping--g1.png';
import icon381 from './information--train-or-light-rail-station--g1.png';
import icon382 from './information--tram-bus-stop--g1.png';
import icon383 from './information--tram-bus-stop--g2.png';
import icon384 from './information--trams-crossing--g1.png';
import icon385 from './information--truck-lane-left--g1.png';
import icon386 from './information--truck-parking--g1.png';
import icon387 from './information--truck-trailer-lane-right--g1.png';
import icon388 from './information--truck-trailer-lane-straight--g1.png';
import icon389 from './information--trucks-both-ways--g1.png';
import icon390 from './information--trucks-only--g1.png';
import icon391 from './information--tsunami-evacuation_route--g1.png';
import icon392 from './information--tunnel--g1.png';
import icon393 from './information--tunnel--g2.png';
import icon394 from './information--tunnel--g3.png';
import icon395 from './information--tunnel-ahead--g1.png';
import icon396 from './information--turn-left--g1.png';
import icon397 from './information--turn-left-ahead--g1.png';
import icon398 from './information--turn-right--g1.png';
import icon399 from './information--turn-right-ahead--g1.png';
import icon400 from './information--urban-area--g1.png';
import icon401 from './information--vehicles-on-rails--g1.png';
import icon402 from './information--water-protection-zone--g1.png';
import icon403 from './information--weight-and-height-limit--g1.png';
import icon404 from './information--weight-limit--g1.png';
import icon405 from './information--wireless-internet--g1.png';
import icon406 from './regulatory--advisory-maximum-speed-limit--g1.png';
import icon407 from './regulatory--all-directions-permitted--g1.png';
import icon408 from './regulatory--all-way--g1.png';
import icon409 from './regulatory--atvs-permitted--g1.png';
import icon410 from './regulatory--axle-limit--g1.png';
import icon411 from './regulatory--axle-limit--g2.png';
import icon412 from './regulatory--bicycle-lane-left--g1.png';
import icon413 from './regulatory--bicycle-parking--g1.png';
import icon414 from './regulatory--bicycles-and-buses-only--g1.png';
import icon415 from './regulatory--bicycles-only--g1.png';
import icon416 from './regulatory--bicycles-only--g2.png';
import icon417 from './regulatory--bicycles-only--g3.png';
import icon418 from './regulatory--bicycles-only--g4.png';
import icon419 from './regulatory--bicycles-push-button--g1.png';
import icon420 from './regulatory--bicycles-push-button--g2.png';
import icon421 from './regulatory--bicycles-stop-on-red--g1.png';
import icon422 from './regulatory--bicycles-wrong-way--g1.png';
import icon423 from './regulatory--bicycles-yield-or-use-signal--g1.png';
import icon424 from './regulatory--bike-route--g1.png';
import icon425 from './regulatory--building-direction--g1.png';
import icon426 from './regulatory--bus-priority-lane--g1.png';
import icon427 from './regulatory--buses-and-taxi-only--g1.png';
import icon428 from './regulatory--buses-only--g1.png';
import icon429 from './regulatory--buses-only--g2.png';
import icon430 from './regulatory--circular-intersection--g1.png';
import icon431 from './regulatory--circular-intersection--g2.png';
import icon432 from './regulatory--circular-intersection--g3.png';
import icon433 from './regulatory--circular-intersection--g4.png';
import icon434 from './regulatory--cross-only-on-green--g1.png';
import icon435 from './regulatory--cross-only-on-pedestrian-signal--g1.png';
import icon436 from './regulatory--crosswalk-stop-on-red--g1.png';
import icon437 from './regulatory--cycling-restriction--g1.png';
import icon438 from './regulatory--cyclists-dismount-and-walk--g1.png';
import icon439 from './regulatory--detour-left--g1.png';
import icon440 from './regulatory--detour-right--g1.png';
import icon441 from './regulatory--divided-highway-crossing--g1.png';
import icon442 from './regulatory--divided-highway-ends--g1.png';
import icon443 from './regulatory--divided-highway-starts--g1.png';
import icon444 from './regulatory--do-not-block-intersection--g1.png';
import icon445 from './regulatory--do-not-pass--g1.png';
import icon446 from './regulatory--do-not-stop-on-tracks--g1.png';
import icon447 from './regulatory--dual-lanes-all-directions-on-left--g1.png';
import icon448 from './regulatory--dual-lanes-all-directions-on-right--g1.png';
import icon449 from './regulatory--dual-lanes-bicyclists-and-pedestrians--g1.png';
import icon450 from './regulatory--dual-lanes-go-left-or-right--g1.png';
import icon451 from './regulatory--dual-lanes-go-straight-on-left--g1.png';
import icon452 from './regulatory--dual-lanes-go-straight-on-right--g1.png';
import icon453 from './regulatory--dual-lanes-turn-left--g1.png';
import icon454 from './regulatory--dual-lanes-turn-left-no-u-turn--g1.png';
import icon455 from './regulatory--dual-lanes-turn-left-or-straight--g1.png';
import icon456 from './regulatory--dual-lanes-turn-right-or-straight--g1.png';
import icon457 from './regulatory--dual-path-bicycles-and-pedestrians--g1.png';
import icon458 from './regulatory--dual-path-bicycles-and-pedestrians--g2.png';
import icon459 from './regulatory--dual-path-bicycles-and-pedestrians--g3.png';
import icon460 from './regulatory--dual-path-equestrians-and-pedestrians--g1.png';
import icon461 from './regulatory--dual-path-equestrians-and-pedestrians-bicycles--g1.png';
import icon462 from './regulatory--dual-path-pedestrians-and-bicycles--g1.png';
import icon463 from './regulatory--dual-path-pedestrians-and-bicycles--g2.png';
import icon464 from './regulatory--dual-path-pedestrians-and-equestrians--g1.png';
import icon465 from './regulatory--dual-path-pedestrians-bicycles-and-equestrians--g1.png';
import icon466 from './regulatory--dual-speed-limits--g1.png';
import icon467 from './regulatory--dual-speed-limits--g2.png';
import icon468 from './regulatory--end-of-bicycles-only--g1.png';
import icon469 from './regulatory--end-of-bicycles-only--g2.png';
import icon470 from './regulatory--end-of-bus-and-taxi-only--g1.png';
import icon471 from './regulatory--end-of-buses-only--g1.png';
import icon472 from './regulatory--end-of-buses-only--g2.png';
import icon473 from './regulatory--end-of-cycling-restriction--g1.png';
import icon474 from './regulatory--end-of-dual-path-bicycles-and-pedestrians--g1.png';
import icon475 from './regulatory--end-of-dual-path-pedestrians-and-bicycles--g1.png';
import icon476 from './regulatory--end-of-equestrians-only--g1.png';
import icon477 from './regulatory--end-of-low-beam-headlights--g1.png';
import icon478 from './regulatory--end-of-maximum-speed-limit-10--g1.png';
import icon479 from './regulatory--end-of-maximum-speed-limit-10--g2.png';
import icon480 from './regulatory--end-of-maximum-speed-limit-20--g1.png';
import icon481 from './regulatory--end-of-maximum-speed-limit-20--g2.png';
import icon482 from './regulatory--end-of-maximum-speed-limit-25--g1.png';
import icon483 from './regulatory--end-of-maximum-speed-limit-25--g2.png';
import icon484 from './regulatory--end-of-maximum-speed-limit-30--g1.png';
import icon485 from './regulatory--end-of-maximum-speed-limit-30--g2.png';
import icon486 from './regulatory--end-of-maximum-speed-limit-35--g1.png';
import icon487 from './regulatory--end-of-maximum-speed-limit-35--g2.png';
import icon488 from './regulatory--end-of-maximum-speed-limit-40--g1.png';
import icon489 from './regulatory--end-of-maximum-speed-limit-40--g2.png';
import icon490 from './regulatory--end-of-maximum-speed-limit-50--g1.png';
import icon491 from './regulatory--end-of-maximum-speed-limit-50--g2.png';
import icon492 from './regulatory--end-of-maximum-speed-limit-60--g1.png';
import icon493 from './regulatory--end-of-maximum-speed-limit-60--g2.png';
import icon494 from './regulatory--end-of-maximum-speed-limit-65--g1.png';
import icon495 from './regulatory--end-of-maximum-speed-limit-65--g2.png';
import icon496 from './regulatory--end-of-maximum-speed-limit-70--g1.png';
import icon497 from './regulatory--end-of-maximum-speed-limit-70--g2.png';
import icon498 from './regulatory--end-of-maximum-speed-limit-75--g1.png';
import icon499 from './regulatory--end-of-maximum-speed-limit-75--g2.png';
import icon500 from './regulatory--end-of-maximum-speed-limit-80--g1.png';
import icon501 from './regulatory--end-of-maximum-speed-limit-80--g2.png';
import icon502 from './regulatory--end-of-maximum-speed-limit-90--g1.png';
import icon503 from './regulatory--end-of-maximum-speed-limit-90--g2.png';
import icon504 from './regulatory--end-of-maximum-speed-limit-100--g1.png';
import icon505 from './regulatory--end-of-maximum-speed-limit-100--g2.png';
import icon506 from './regulatory--end-of-maximum-speed-limit-110--g1.png';
import icon507 from './regulatory--end-of-maximum-speed-limit-110--g2.png';
import icon508 from './regulatory--end-of-maximum-speed-limit-120--g1.png';
import icon509 from './regulatory--end-of-maximum-speed-limit-120--g2.png';
import icon510 from './regulatory--end-of-maximum-speed-limit-130--g1.png';
import icon511 from './regulatory--end-of-maximum-speed-limit-130--g2.png';
import icon512 from './regulatory--end-of-maximum-speed-limit--g1.png';
import icon513 from './regulatory--end-of-mopeds-and-bicycles-only--g1.png';
import icon514 from './regulatory--end-of-no-heavy-goods-vehicles--g1.png';
import icon515 from './regulatory--end-of-no-horn--g1.png';
import icon516 from './regulatory--end-of-no-overtaking--g1.png';
import icon517 from './regulatory--end-of-no-overtaking--g2.png';
import icon518 from './regulatory--end-of-no-overtaking--g3.png';
import icon519 from './regulatory--end-of-no-overtaking--g4.png';
import icon520 from './regulatory--end-of-no-overtaking--g5.png';
import icon521 from './regulatory--end-of-no-overtaking-by-heavy-goods-vehicles--g1.png';
import icon522 from './regulatory--end-of-no-overtaking-by-heavy-goods-vehicles--g2.png';
import icon523 from './regulatory--end-of-no-overtaking-by-motorcycles--g1.png';
import icon524 from './regulatory--end-of-no-parking--g1.png';
import icon525 from './regulatory--end-of-no-parking--g2.png';
import icon526 from './regulatory--end-of-no-parking-or-stopping--g1.png';
import icon527 from './regulatory--end-of-one-way-straight--g1.png';
import icon528 from './regulatory--end-of-parking-zone--g1.png';
import icon529 from './regulatory--end-of-parking-zone--g2.png';
import icon530 from './regulatory--end-of-pedestrians-only--g1.png';
import icon531 from './regulatory--end-of-pedestrians-only--g2.png';
import icon532 from './regulatory--end-of-pedestrians-only--g3.png';
import icon533 from './regulatory--end-of-pedestrians-only--g4.png';
import icon534 from './regulatory--end-of-priority-road--g1.png';
import icon535 from './regulatory--end-of-prohibition--g1.png';
import icon536 from './regulatory--end-of-school-zone--g1.png';
import icon537 from './regulatory--end-of-shared-path-bicycles-and-pedestrians--g1.png';
import icon538 from './regulatory--end-of-shared-path-pedestrians-and-bicycles--g1.png';
import icon539 from './regulatory--end-of-snow-chains--g1.png';
import icon540 from './regulatory--end-of-snow-chains--g2.png';
import icon541 from './regulatory--end-of-snowmobiles-only--g1.png';
import icon542 from './regulatory--end-of-speed-limit-zone--g1.png';
import icon543 from './regulatory--end-of-speed-limit-zone--g2.png';
import icon544 from './regulatory--end-of-speed-limit-zone--g3.png';
import icon545 from './regulatory--end-of-tractors-only--g1.png';
import icon546 from './regulatory--end-of-trams-and-buses-only--g1.png';
import icon547 from './regulatory--end-of-trams-only--g1.png';
import icon548 from './regulatory--end-of-trucks-and-buses-only--g1.png';
import icon549 from './regulatory--end-of-trucks-only--g1.png';
import icon550 from './regulatory--end-of-trucks-only--g2.png';
import icon551 from './regulatory--equestrians-only--g1.png';
import icon552 from './regulatory--except-railroad-crossing--g1.png';
import icon553 from './regulatory--fine-for-littering--g1.png';
import icon554 from './regulatory--give-way-to-bicycles--g1.png';
import icon555 from './regulatory--give-way-to-oncoming-traffic--g1.png';
import icon556 from './regulatory--give-way-to-oncoming-traffic--g2.png';
import icon557 from './regulatory--go-left-bicycles--g1.png';
import icon558 from './regulatory--go-right-bicycles--g1.png';
import icon559 from './regulatory--go-straight--g1.png';
import icon560 from './regulatory--go-straight--g3.png';
import icon561 from './regulatory--go-straight-bicycles--g1.png';
import icon562 from './regulatory--go-straight-or-turn-left--g1.png';
import icon563 from './regulatory--go-straight-or-turn-left--g2.png';
import icon564 from './regulatory--go-straight-or-turn-left--g3.png';
import icon565 from './regulatory--go-straight-or-turn-right--g1.png';
import icon566 from './regulatory--go-straight-or-turn-right--g2.png';
import icon567 from './regulatory--go-straight-or-turn-right--g3.png';
import icon568 from './regulatory--heavy-goods-vehicles-permitted--g1.png';
import icon569 from './regulatory--height-limit--g1.png';
import icon570 from './regulatory--high-beam-headlights--g1.png';
import icon571 from './regulatory--horn--g1.png';
import icon572 from './regulatory--in-street-pedestrian-crossing--g1.png';
import icon573 from './regulatory--keep-left--g1.png';
import icon574 from './regulatory--keep-left--g2.png';
import icon575 from './regulatory--keep-left--g3.png';
import icon576 from './regulatory--keep-left--g4.png';
import icon577 from './regulatory--keep-left--g5.png';
import icon578 from './regulatory--keep-left--g6.png';
import icon579 from './regulatory--keep-left--g7.png';
import icon580 from './regulatory--keep-right--g1.png';
import icon581 from './regulatory--keep-right--g2.png';
import icon582 from './regulatory--keep-right--g3.png';
import icon583 from './regulatory--keep-right--g4.png';
import icon584 from './regulatory--keep-right--g5.png';
import icon585 from './regulatory--keep-right--g6.png';
import icon586 from './regulatory--keep-right--g7.png';
import icon587 from './regulatory--keep-right--g8.png';
import icon588 from './regulatory--keep-right--g9.png';
import icon589 from './regulatory--lane-control--g1.png';
import icon590 from './regulatory--left-turn-yield-on-green--g1.png';
import icon591 from './regulatory--length-limit--g1.png';
import icon592 from './regulatory--length-limit--g2.png';
import icon593 from './regulatory--light-rail-divided-highway--g1.png';
import icon594 from './regulatory--light-rail-do-not-pass--g1.png';
import icon595 from './regulatory--light-rail-only--g1.png';
import icon596 from './regulatory--look--g1.png';
import icon597 from './regulatory--low-beam-headlights--g1.png';
import icon598 from './regulatory--low-beam-headlights--g2.png';
import icon599 from './regulatory--low-beam-headlights--g3.png';
import icon600 from './regulatory--low-speed-vehicle-permitted--g1.png';
import icon601 from './regulatory--maximum-speed-limit-5--g1.png';
import icon602 from './regulatory--maximum-speed-limit-5--g3.png';
import icon603 from './regulatory--maximum-speed-limit-10--g1.png';
import icon604 from './regulatory--maximum-speed-limit-10--g3.png';
import icon605 from './regulatory--maximum-speed-limit-15--g1.png';
import icon606 from './regulatory--maximum-speed-limit-15--g3.png';
import icon607 from './regulatory--maximum-speed-limit-20--g1.png';
import icon608 from './regulatory--maximum-speed-limit-20--g3.png';
import icon609 from './regulatory--maximum-speed-limit-25--g1.png';
import icon610 from './regulatory--maximum-speed-limit-25--g2.png';
import icon611 from './regulatory--maximum-speed-limit-30--g1.png';
import icon612 from './regulatory--maximum-speed-limit-30--g3.png';
import icon613 from './regulatory--maximum-speed-limit-35--g1.png';
import icon614 from './regulatory--maximum-speed-limit-35--g2.png';
import icon615 from './regulatory--maximum-speed-limit-40--g1.png';
import icon616 from './regulatory--maximum-speed-limit-40--g3.png';
import icon617 from './regulatory--maximum-speed-limit-45--g1.png';
import icon618 from './regulatory--maximum-speed-limit-45--g3.png';
import icon619 from './regulatory--maximum-speed-limit-50--g1.png';
import icon620 from './regulatory--maximum-speed-limit-50--g3.png';
import icon621 from './regulatory--maximum-speed-limit-55--g2.png';
import icon622 from './regulatory--maximum-speed-limit-60--g1.png';
import icon623 from './regulatory--maximum-speed-limit-60--g3.png';
import icon624 from './regulatory--maximum-speed-limit-65--g1.png';
import icon625 from './regulatory--maximum-speed-limit-65--g2.png';
import icon626 from './regulatory--maximum-speed-limit-70--g1.png';
import icon627 from './regulatory--maximum-speed-limit-70--g3.png';
import icon628 from './regulatory--maximum-speed-limit-75--g2.png';
import icon629 from './regulatory--maximum-speed-limit-80--g1.png';
import icon630 from './regulatory--maximum-speed-limit-80--g3.png';
import icon631 from './regulatory--maximum-speed-limit-85--g2.png';
import icon632 from './regulatory--maximum-speed-limit-90--g1.png';
import icon633 from './regulatory--maximum-speed-limit-90--g3.png';
import icon634 from './regulatory--maximum-speed-limit-100--g1.png';
import icon635 from './regulatory--maximum-speed-limit-100--g3.png';
import icon636 from './regulatory--maximum-speed-limit-110--g1.png';
import icon637 from './regulatory--maximum-speed-limit-110--g3.png';
import icon638 from './regulatory--maximum-speed-limit-120--g1.png';
import icon639 from './regulatory--maximum-speed-limit-120--g3.png';
import icon640 from './regulatory--maximum-speed-limit-130--g1.png';
import icon641 from './regulatory--maximum-speed-limit-130--g3.png';
import icon642 from './regulatory--maximum-speed-limit-led-5--g2.png';
import icon643 from './regulatory--maximum-speed-limit-led-5--g3.png';
import icon644 from './regulatory--maximum-speed-limit-led-10--g1.png';
import icon645 from './regulatory--maximum-speed-limit-led-10--g2.png';
import icon646 from './regulatory--maximum-speed-limit-led-10--g3.png';
import icon647 from './regulatory--maximum-speed-limit-led-15--g2.png';
import icon648 from './regulatory--maximum-speed-limit-led-15--g3.png';
import icon649 from './regulatory--maximum-speed-limit-led-20--g1.png';
import icon650 from './regulatory--maximum-speed-limit-led-20--g2.png';
import icon651 from './regulatory--maximum-speed-limit-led-20--g3.png';
import icon652 from './regulatory--maximum-speed-limit-led-25--g1.png';
import icon653 from './regulatory--maximum-speed-limit-led-25--g2.png';
import icon654 from './regulatory--maximum-speed-limit-led-25--g3.png';
import icon655 from './regulatory--maximum-speed-limit-led-30--g1.png';
import icon656 from './regulatory--maximum-speed-limit-led-30--g2.png';
import icon657 from './regulatory--maximum-speed-limit-led-30--g3.png';
import icon658 from './regulatory--maximum-speed-limit-led-35--g1.png';
import icon659 from './regulatory--maximum-speed-limit-led-35--g2.png';
import icon660 from './regulatory--maximum-speed-limit-led-35--g3.png';
import icon661 from './regulatory--maximum-speed-limit-led-40--g1.png';
import icon662 from './regulatory--maximum-speed-limit-led-40--g2.png';
import icon663 from './regulatory--maximum-speed-limit-led-40--g3.png';
import icon664 from './regulatory--maximum-speed-limit-led-45--g2.png';
import icon665 from './regulatory--maximum-speed-limit-led-45--g3.png';
import icon666 from './regulatory--maximum-speed-limit-led-50--g1.png';
import icon667 from './regulatory--maximum-speed-limit-led-50--g2.png';
import icon668 from './regulatory--maximum-speed-limit-led-50--g3.png';
import icon669 from './regulatory--maximum-speed-limit-led-55--g2.png';
import icon670 from './regulatory--maximum-speed-limit-led-55--g3.png';
import icon671 from './regulatory--maximum-speed-limit-led-60--g1.png';
import icon672 from './regulatory--maximum-speed-limit-led-60--g2.png';
import icon673 from './regulatory--maximum-speed-limit-led-60--g3.png';
import icon674 from './regulatory--maximum-speed-limit-led-65--g2.png';
import icon675 from './regulatory--maximum-speed-limit-led-65--g3.png';
import icon676 from './regulatory--maximum-speed-limit-led-70--g1.png';
import icon677 from './regulatory--maximum-speed-limit-led-70--g2.png';
import icon678 from './regulatory--maximum-speed-limit-led-70--g3.png';
import icon679 from './regulatory--maximum-speed-limit-led-75--g1.png';
import icon680 from './regulatory--maximum-speed-limit-led-75--g2.png';
import icon681 from './regulatory--maximum-speed-limit-led-75--g3.png';
import icon682 from './regulatory--maximum-speed-limit-led-80--g1.png';
import icon683 from './regulatory--maximum-speed-limit-led-80--g2.png';
import icon684 from './regulatory--maximum-speed-limit-led-80--g3.png';
import icon685 from './regulatory--maximum-speed-limit-led-85--g2.png';
import icon686 from './regulatory--maximum-speed-limit-led-85--g3.png';
import icon687 from './regulatory--maximum-speed-limit-led-90--g1.png';
import icon688 from './regulatory--maximum-speed-limit-led-100--g1.png';
import icon689 from './regulatory--maximum-speed-limit-led-110--g1.png';
import icon690 from './regulatory--maximum-speed-limit-led-120--g1.png';
import icon691 from './regulatory--maximum-speed-limit-led-130--g1.png';
import icon692 from './regulatory--minimum-safe-distance--g1.png';
import icon693 from './regulatory--minimum-safe-distance--g2.png';
import icon694 from './regulatory--mopeds-and-bicycles-only--g1.png';
import icon695 from './regulatory--motorcycles-and-bicycles-only--g1.png';
import icon696 from './regulatory--motorcycles-only--g1.png';
import icon697 from './regulatory--motorcycles-only--g2.png';
import icon698 from './regulatory--night-speed-limit-5--g1.png';
import icon699 from './regulatory--night-speed-limit-10--g1.png';
import icon700 from './regulatory--night-speed-limit-15--g1.png';
import icon701 from './regulatory--night-speed-limit-20--g1.png';
import icon702 from './regulatory--night-speed-limit-25--g1.png';
import icon703 from './regulatory--night-speed-limit-30--g1.png';
import icon704 from './regulatory--night-speed-limit-35--g1.png';
import icon705 from './regulatory--night-speed-limit-40--g1.png';
import icon706 from './regulatory--night-speed-limit-45--g1.png';
import icon707 from './regulatory--night-speed-limit-50--g1.png';
import icon708 from './regulatory--night-speed-limit-55--g1.png';
import icon709 from './regulatory--night-speed-limit-60--g1.png';
import icon710 from './regulatory--night-speed-limit-65--g1.png';
import icon711 from './regulatory--night-speed-limit-70--g1.png';
import icon712 from './regulatory--night-speed-limit-75--g1.png';
import icon713 from './regulatory--night-speed-limit-80--g1.png';
import icon714 from './regulatory--night-speed-limit-85--g1.png';
import icon715 from './regulatory--no-abnormal-vehicles--g1.png';
import icon716 from './regulatory--no-atvs--g1.png';
import icon717 from './regulatory--no-bicycles--g1.png';
import icon718 from './regulatory--no-bicycles--g2.png';
import icon719 from './regulatory--no-bicycles--g3.png';
import icon720 from './regulatory--no-bicycles-carts-or-hand-carts--g1.png';
import icon721 from './regulatory--no-bicycles-mopeds-or-motorcycles--g1.png';
import icon722 from './regulatory--no-bicycles-mopeds-or-motorcycles--g2.png';
import icon723 from './regulatory--no-bicycles-or-hand-carts--g1.png';
import icon724 from './regulatory--no-bicycles-or-motorcycles--g1.png';
import icon725 from './regulatory--no-bicycles-tractors-or-carts--g1.png';
import icon726 from './regulatory--no-buses--g1.png';
import icon727 from './regulatory--no-buses--g2.png';
import icon728 from './regulatory--no-buses--g3.png';
import icon729 from './regulatory--no-caravan-trailers--g1.png';
import icon730 from './regulatory--no-caravans--g1.png';
import icon731 from './regulatory--no-caravans-or-caravan-trailers--g1.png';
import icon732 from './regulatory--no-cargo-loading--g1.png';
import icon733 from './regulatory--no-carts--g1.png';
import icon734 from './regulatory--no-carts--g2.png';
import icon735 from './regulatory--no-carts--g3.png';
import icon736 from './regulatory--no-carts-or-tractors--g1.png';
import icon737 from './regulatory--no-construction-vehicles--g1.png';
import icon738 from './regulatory--no-entry--g1.png';
import icon739 from './regulatory--no-equestrians--g1.png';
import icon740 from './regulatory--no-go-straight-or-turn-left--g1.png';
import icon741 from './regulatory--no-go-straight-or-turn-right--g1.png';
import icon742 from './regulatory--no-good-trailers--g2.png';
import icon743 from './regulatory--no-goods-vehicle-trailers--g1.png';
import icon744 from './regulatory--no-hand-carts--g1.png';
import icon745 from './regulatory--no-hand-carts--g2.png';
import icon746 from './regulatory--no-hand-carts-or-bicycles--g1.png';
import icon747 from './regulatory--no-hawkers--g1.png';
import icon748 from './regulatory--no-heavy-goods-vehicles--g1.png';
import icon749 from './regulatory--no-heavy-goods-vehicles--g2.png';
import icon750 from './regulatory--no-heavy-goods-vehicles--g3.png';
import icon751 from './regulatory--no-heavy-goods-vehicles--g4.png';
import icon752 from './regulatory--no-heavy-goods-vehicles--g5.png';
import icon753 from './regulatory--no-heavy-goods-vehicles-motorcycles-or-bicycles--g1.png';
import icon754 from './regulatory--no-heavy-goods-vehicles-motorcycles-or-bicycles--g2.png';
import icon755 from './regulatory--no-heavy-goods-vehicles-or-buses--g1.png';
import icon756 from './regulatory--no-heavy-goods-vehicles-or-tractors--g1.png';
import icon757 from './regulatory--no-heavy-goods-vehicles-or-trailers--g1.png';
import icon758 from './regulatory--no-horizontal-turn--g1.png';
import icon759 from './regulatory--no-horn--g1.png';
import icon760 from './regulatory--no-horn--g2.png';
import icon761 from './regulatory--no-lane-change-to-left--g1.png';
import icon762 from './regulatory--no-lane-change-to-right--g1.png';
import icon763 from './regulatory--no-learner-drivers--g1.png';
import icon764 from './regulatory--no-left-or-u-turn--g1.png';
import icon765 from './regulatory--no-left-turn--g1.png';
import icon766 from './regulatory--no-left-turn--g2.png';
import icon767 from './regulatory--no-left-turn--g3.png';
import icon768 from './regulatory--no-left-turn--g4.png';
import icon769 from './regulatory--no-left-turn--g5.png';
import icon770 from './regulatory--no-low-speed-vehicles--g1.png';
import icon771 from './regulatory--no-mopeds-or-bicycles--g1.png';
import icon772 from './regulatory--no-motor-vehicle-trailers--g1.png';
import icon773 from './regulatory--no-motor-vehicles--g1.png';
import icon774 from './regulatory--no-motor-vehicles--g3.png';
import icon775 from './regulatory--no-motor-vehicles--g4.png';
import icon776 from './regulatory--no-motor-vehicles--g5.png';
import icon777 from './regulatory--no-motor-vehicles--g6.png';
import icon778 from './regulatory--no-motor-vehicles--g7.png';
import icon779 from './regulatory--no-motor-vehicles-except-motorcycles--g1.png';
import icon780 from './regulatory--no-motor-vehicles-except-motorcycles--g2.png';
import icon781 from './regulatory--no-motor-vehicles-except-motorcycles--g3.png';
import icon782 from './regulatory--no-motor-vehicles-or-bicycles--g1.png';
import icon783 from './regulatory--no-motor-vehicles-or-buses--g1.png';
import icon784 from './regulatory--no-motor-vehicles-or-carts--g1.png';
import icon785 from './regulatory--no-motorcycles--g1.png';
import icon786 from './regulatory--no-motorcycles--g2.png';
import icon787 from './regulatory--no-overtaking--g1.png';
import icon788 from './regulatory--no-overtaking--g2.png';
import icon789 from './regulatory--no-overtaking--g4.png';
import icon790 from './regulatory--no-overtaking--g5.png';
import icon791 from './regulatory--no-overtaking--g6.png';
import icon792 from './regulatory--no-overtaking--g7.png';
import icon793 from './regulatory--no-overtaking-atvs--g1.png';
import icon794 from './regulatory--no-overtaking-by-heavy-goods-vehicles--g1.png';
import icon795 from './regulatory--no-parking--g1.png';
import icon796 from './regulatory--no-parking--g2.png';
import icon797 from './regulatory--no-parking--g3.png';
import icon798 from './regulatory--no-parking--g4.png';
import icon799 from './regulatory--no-parking--g5.png';
import icon800 from './regulatory--no-parking--g6.png';
import icon801 from './regulatory--no-parking--g7.png';
import icon802 from './regulatory--no-parking--g8.png';
import icon803 from './regulatory--no-parking--g9.png';
import icon804 from './regulatory--no-parking-bicycles-or-motorcycles--g1.png';
import icon805 from './regulatory--no-parking-bus-stop--g1.png';
import icon806 from './regulatory--no-parking-or-no-stopping--g1.png';
import icon807 from './regulatory--no-parking-or-no-stopping--g2.png';
import icon808 from './regulatory--no-parking-or-no-stopping--g3.png';
import icon809 from './regulatory--no-parking-or-no-stopping--g4.png';
import icon810 from './regulatory--no-parking-or-no-stopping--g5.png';
import icon811 from './regulatory--no-passenger-loading--g1.png';
import icon812 from './regulatory--no-pedestrians--g1.png';
import icon813 from './regulatory--no-pedestrians--g2.png';
import icon814 from './regulatory--no-pedestrians--g3.png';
import icon815 from './regulatory--no-pedestrians--g4.png';
import icon816 from './regulatory--no-pedestrians--g5.png';
import icon817 from './regulatory--no-pedestrians--g6.png';
import icon818 from './regulatory--no-pedestrians-bicycles-animals-or-hand-carts--g1.png';
import icon819 from './regulatory--no-pedestrians-or-bicycles--g1.png';
import icon820 from './regulatory--no-pedestrians-or-bicycles--g2.png';
import icon821 from './regulatory--no-pedestrians-or-bicycles--g3.png';
import icon822 from './regulatory--no-rickshaws--g1.png';
import icon823 from './regulatory--no-rickshaws--g2.png';
import icon824 from './regulatory--no-rickshaws--g3.png';
import icon825 from './regulatory--no-right-turn--g1.png';
import icon826 from './regulatory--no-right-turn--g2.png';
import icon827 from './regulatory--no-right-turn--g3.png';
import icon828 from './regulatory--no-right-turn-on-red--g1.png';
import icon829 from './regulatory--no-skiing--g1.png';
import icon830 from './regulatory--no-snowmobiles--g1.png';
import icon831 from './regulatory--no-snowmobiles--g2.png';
import icon832 from './regulatory--no-snowmobiles-or-atvs--g1.png';
import icon833 from './regulatory--no-stopping--g1.png';
import icon834 from './regulatory--no-stopping--g2.png';
import icon835 from './regulatory--no-stopping--g3.png';
import icon836 from './regulatory--no-stopping--g5.png';
import icon837 from './regulatory--no-stopping--g6.png';
import icon838 from './regulatory--no-stopping--g7.png';
import icon839 from './regulatory--no-stopping-on-pavement--g1.png';
import icon840 from './regulatory--no-straight-through--g1.png';
import icon841 from './regulatory--no-straight-through--g2.png';
import icon842 from './regulatory--no-studded-snow-chains--g1.png';
import icon843 from './regulatory--no-through-trucks--g1.png';
import icon844 from './regulatory--no-tour-buses--g1.png';
import icon845 from './regulatory--no-tractors--g1.png';
import icon846 from './regulatory--no-tractors-mopeds-or-bicycles--g1.png';
import icon847 from './regulatory--no-tractors-or-carts--g1.png';
import icon848 from './regulatory--no-trailers--g1.png';
import icon849 from './regulatory--no-tricycles--g1.png';
import icon850 from './regulatory--no-tricycles-or-hand-carts--g1.png';
import icon851 from './regulatory--no-turn-on-red--g1.png';
import icon852 from './regulatory--no-turn-on-red--g2.png';
import icon853 from './regulatory--no-turn-on-red--g3.png';
import icon854 from './regulatory--no-turns--g1.png';
import icon855 from './regulatory--no-turns--g2.png';
import icon856 from './regulatory--no-two-stage-right-turn-for-mopeds--g1.png';
import icon857 from './regulatory--no-u-turn--g1.png';
import icon858 from './regulatory--no-u-turn--g2.png';
import icon859 from './regulatory--no-u-turn--g3.png';
import icon860 from './regulatory--no-vehicles-carrying-dangerous-goods--g1.png';
import icon861 from './regulatory--no-vehicles-carrying-dangerous-goods--g2.png';
import icon862 from './regulatory--no-vehicles-carrying-dangerous-goods--g3.png';
import icon863 from './regulatory--no-vehicles-carrying-dangerous-goods--g4.png';
import icon864 from './regulatory--no-vehicles-carrying-dangerous-water-pollutants--g1.png';
import icon865 from './regulatory--no-vehicles-carrying-dangerous-water-pollutants--g2.png';
import icon866 from './regulatory--no-vehicles-carrying-explosives--g1.png';
import icon867 from './regulatory--no-vehicles-carrying-explosives-or-dangerous-water-pollutants--g1.png';
import icon868 from './regulatory--one-way-left--g1.png';
import icon869 from './regulatory--one-way-left--g2.png';
import icon870 from './regulatory--one-way-left--g3.png';
import icon871 from './regulatory--one-way-right--g1.png';
import icon872 from './regulatory--one-way-right--g2.png';
import icon873 from './regulatory--one-way-right--g3.png';
import icon874 from './regulatory--one-way-straight--g1.png';
import icon875 from './regulatory--one-way-straight--g3.png';
import icon876 from './regulatory--parking-fee-station--g1.png';
import icon877 from './regulatory--parking-restrictions--g1.png';
import icon878 from './regulatory--parking-restrictions--g2.png';
import icon879 from './regulatory--parking-restrictions--g3.png';
import icon880 from './regulatory--pass-on-either-side--g1.png';
import icon881 from './regulatory--pass-on-either-side--g2.png';
import icon882 from './regulatory--pass-on-either-side--g3.png';
import icon883 from './regulatory--pass-with-care--g1.png';
import icon884 from './regulatory--passing-lane-ahead--g1.png';
import icon885 from './regulatory--pedestrians-bicycles-permitted--g1.png';
import icon886 from './regulatory--pedestrians-keep-left--g1.png';
import icon887 from './regulatory--pedestrians-only--g1.png';
import icon888 from './regulatory--pedestrians-only--g2.png';
import icon889 from './regulatory--pedestrians-only--g3.png';
import icon890 from './regulatory--pedestrians-priority-zone--g1.png';
import icon891 from './regulatory--pedestrians-push-button--g1.png';
import icon892 from './regulatory--pedestrians-push-button--g2.png';
import icon893 from './regulatory--priority-over-oncoming-vehicles--g1.png';
import icon894 from './regulatory--priority-over-oncoming-vehicles--g2.png';
import icon895 from './regulatory--priority-road--g1.png';
import icon896 from './regulatory--priority-road--g2.png';
import icon897 from './regulatory--radar-enforced--g1.png';
import icon898 from './regulatory--reserved-parking--g1.png';
import icon899 from './regulatory--reversible-lanes--g1.png';
import icon900 from './regulatory--reversible-lanes--g2.png';
import icon901 from './regulatory--road-closed--g1.png';
import icon902 from './regulatory--road-closed--g2.png';
import icon903 from './regulatory--road-closed-to-vehicles--g1.png';
import icon904 from './regulatory--road-closed-to-vehicles--g3.png';
import icon905 from './regulatory--roundabout--g1.png';
import icon906 from './regulatory--roundabout--g2.png';
import icon907 from './regulatory--roundabout--g3.png';
import icon908 from './regulatory--shared-path-bicycles-and-pedestrians--g1.png';
import icon909 from './regulatory--shared-path-pedestrians-and-bicycles--g1.png';
import icon910 from './regulatory--sidewalk-closed--g1.png';
import icon911 from './regulatory--slanted-parking--g1.png';
import icon912 from './regulatory--snow-chains--g1.png';
import icon913 from './regulatory--snow-chains--g2.png';
import icon914 from './regulatory--snow-chains--g3.png';
import icon915 from './regulatory--snowmobiles-only--g1.png';
import icon916 from './regulatory--snowmobiles-permitted--g1.png';
import icon917 from './regulatory--speed-limit-zone--g1.png';
import icon918 from './regulatory--speeding-fines-increased--g1.png';
import icon919 from './regulatory--state-route--g1.png';
import icon920 from './regulatory--stay-in-lane--g1.png';
import icon921 from './regulatory--stop--g1.png';
import icon922 from './regulatory--stop--g2.png';
import icon923 from './regulatory--stop--g3.png';
import icon924 from './regulatory--stop--g4.png';
import icon925 from './regulatory--stop--g5.png';
import icon926 from './regulatory--stop--g6.png';
import icon927 from './regulatory--stop--g7.png';
import icon928 from './regulatory--stop--g8.png';
import icon929 from './regulatory--stop--g9.png';
import icon930 from './regulatory--stop--g10.png';
import icon931 from './regulatory--stop-here-on-red-or-flashing-light--g1.png';
import icon932 from './regulatory--stop-here-on-red-or-flashing-light--g2.png';
import icon933 from './regulatory--stop-signals--g1.png';
import icon934 from './regulatory--stop-signals--g2.png';
import icon935 from './regulatory--tanks-only--g1.png';
import icon936 from './regulatory--taxi-only--g1.png';
import icon937 from './regulatory--text--g1.png';
import icon938 from './regulatory--text--g2.png';
import icon939 from './regulatory--toll-pass-only--g1.png';
import icon940 from './regulatory--tractors-only--g1.png';
import icon941 from './regulatory--traffic-signal-photo-enforced--g1.png';
import icon942 from './regulatory--trams-and-buses-only--g1.png';
import icon943 from './regulatory--trams-only--g1.png';
import icon944 from './regulatory--triple-lanes--g1.png';
import icon945 from './regulatory--triple-lanes-go-straight-center-lane--g1.png';
import icon946 from './regulatory--triple-lanes-turn-left-center-lane--g1.png';
import icon947 from './regulatory--triple-lanes-turn-right-center-lane--g1.png';
import icon948 from './regulatory--truck-route--g1.png';
import icon949 from './regulatory--truck-speed-limit-5--g1.png';
import icon950 from './regulatory--truck-speed-limit-10--g1.png';
import icon951 from './regulatory--truck-speed-limit-15--g1.png';
import icon952 from './regulatory--truck-speed-limit-20--g1.png';
import icon953 from './regulatory--truck-speed-limit-25--g1.png';
import icon954 from './regulatory--truck-speed-limit-30--g1.png';
import icon955 from './regulatory--truck-speed-limit-35--g1.png';
import icon956 from './regulatory--truck-speed-limit-40--g1.png';
import icon957 from './regulatory--truck-speed-limit-45--g1.png';
import icon958 from './regulatory--truck-speed-limit-50--g1.png';
import icon959 from './regulatory--truck-speed-limit-55--g1.png';
import icon960 from './regulatory--truck-speed-limit-60--g1.png';
import icon961 from './regulatory--truck-speed-limit-65--g1.png';
import icon962 from './regulatory--truck-speed-limit-70--g1.png';
import icon963 from './regulatory--truck-speed-limit-75--g1.png';
import icon964 from './regulatory--truck-speed-limit-80--g1.png';
import icon965 from './regulatory--truck-speed-limit-85--g1.png';
import icon966 from './regulatory--trucks-and-buses-only--g1.png';
import icon967 from './regulatory--trucks-on-right--g1.png';
import icon968 from './regulatory--trucks-only--g1.png';
import icon969 from './regulatory--turn-left--g1.png';
import icon970 from './regulatory--turn-left--g2.png';
import icon971 from './regulatory--turn-left--g3.png';
import icon972 from './regulatory--turn-left-ahead--g1.png';
import icon973 from './regulatory--turn-left-ahead--g2.png';
import icon974 from './regulatory--turn-left-or-right--g1.png';
import icon975 from './regulatory--turn-left-or-right--g2.png';
import icon976 from './regulatory--turn-left-or-right--g3.png';
import icon977 from './regulatory--turn-left-or-u-turn--g1.png';
import icon978 from './regulatory--turn-right--g1.png';
import icon979 from './regulatory--turn-right--g2.png';
import icon980 from './regulatory--turn-right--g3.png';
import icon981 from './regulatory--turn-right-ahead--g1.png';
import icon982 from './regulatory--turn-right-ahead--g2.png';
import icon983 from './regulatory--turning-vehicles-yield-to-pedestrians--g1.png';
import icon984 from './regulatory--two-stage-right-turn-for-mopeds--g1.png';
import icon985 from './regulatory--two-way--g1.png';
import icon986 from './regulatory--u-turn--g1.png';
import icon987 from './regulatory--u-turn--g2.png';
import icon988 from './regulatory--u-turn--g3.png';
import icon989 from './regulatory--use-crosswalk--g1.png';
import icon990 from './regulatory--vehicles-carrying-dangerous-goods-only--g1.png';
import icon991 from './regulatory--vehicles-carrying-dangerous-goods-permitted--g1.png';
import icon992 from './regulatory--vehicles-carrying-explosives-only--g1.png';
import icon993 from './regulatory--vehicles-carrying-hazardous-goods-permitted--g1.png';
import icon994 from './regulatory--vehicles-only--g1.png';
import icon995 from './regulatory--wear-seat-belt--g1.png';
import icon996 from './regulatory--wear-seat-belt--g2.png';
import icon997 from './regulatory--wear-seat-belt--g3.png';
import icon998 from './regulatory--weight-limit--g1.png';
import icon999 from './regulatory--weight-limit--g2.png';
import icon1000 from './regulatory--weight-limit--g3.png';
import icon1001 from './regulatory--weight-limit--g4.png';
import icon1002 from './regulatory--weight-limit--g5.png';
import icon1003 from './regulatory--weight-limit--g6.png';
import icon1004 from './regulatory--weight-limit--g7.png';
import icon1005 from './regulatory--weight-limit-per-axle--g1.png';
import icon1006 from './regulatory--weight-limit-per-tandem-axle--g1.png';
import icon1007 from './regulatory--weight-limit-with-trucks--g1.png';
import icon1008 from './regulatory--width-limit--g1.png';
import icon1009 from './regulatory--wrong-way--g1.png';
import icon1010 from './regulatory--yield--g1.png';
import icon1011 from './regulatory--yield-or-stop-for-pedestrians--g1.png';
import icon1012 from './regulatory--your-speed--g1.png';
import icon1013 from './warning--accident-area--g1.png';
import icon1014 from './warning--accident-area--g2.png';
import icon1015 from './warning--accident-area--g3.png';
import icon1016 from './warning--accident-area--g4.png';
import icon1017 from './warning--accident-area--g5.png';
import icon1018 from './warning--accident-area--g6.png';
import icon1019 from './warning--accident-area--g7.png';
import icon1020 from './warning--accident-area--g8.png';
import icon1021 from './warning--added-lane-from-entering-roadway--g1.png';
import icon1022 from './warning--added-lane-from-entering-roadway--g2.png';
import icon1023 from './warning--added-lane-left--g1.png';
import icon1024 from './warning--added-lane-right--g1.png';
import icon1025 from './warning--animal-drawn-vehicles--g1.png';
import icon1026 from './warning--arch-bridge--g1.png';
import icon1027 from './warning--atv-and-snowmobiles--g1.png';
import icon1028 from './warning--atv-crossing--g1.png';
import icon1029 from './warning--atv-crossing--g2.png';
import icon1030 from './warning--axle-restriction--g1.png';
import icon1031 from './warning--bear-crossing--g1.png';
import icon1032 from './warning--bear-crossing--g2.png';
import icon1033 from './warning--bicycles-and-others--g1.png';
import icon1034 from './warning--bicycles-caution-on-rail-tracks--g1.png';
import icon1035 from './warning--bicycles-crossing--g1.png';
import icon1036 from './warning--bicycles-crossing--g2.png';
import icon1037 from './warning--bicycles-crossing--g3.png';
import icon1038 from './warning--bicycles-crossing--g4.png';
import icon1039 from './warning--bollard--g1.png';
import icon1040 from './warning--bridge--g1.png';
import icon1041 from './warning--bridge--g2.png';
import icon1042 from './warning--bus-stop-ahead--g1.png';
import icon1043 from './warning--bus-stop-ahead--g2.png';
import icon1044 from './warning--bus-stop-ahead--g3.png';
import icon1045 from './warning--camel-crossing--g1.png';
import icon1046 from './warning--camel-crossing--g2.png';
import icon1047 from './warning--camera--g1.png';
import icon1048 from './warning--camera--g2.png';
import icon1049 from './warning--carts--g1.png';
import icon1050 from './warning--carts--g2.png';
import icon1051 from './warning--checkpoint--g1.png';
import icon1052 from './warning--children--g1.png';
import icon1053 from './warning--children--g2.png';
import icon1054 from './warning--children--g3.png';
import icon1055 from './warning--children--g4.png';
import icon1056 from './warning--children--g6.png';
import icon1057 from './warning--cliff--g1.png';
import icon1058 from './warning--cliff--g2.png';
import icon1059 from './warning--closed-lane-in-triple-lanes--g1.png';
import icon1060 from './warning--closed-lane-in-triple-lanes--g2.png';
import icon1061 from './warning--construction-ahead--g1.png';
import icon1062 from './warning--crossroads--g1.png';
import icon1063 from './warning--crossroads--g2.png';
import icon1064 from './warning--crossroads--g3.png';
import icon1065 from './warning--crossroads--g4.png';
import icon1066 from './warning--crossroads--g5.png';
import icon1067 from './warning--crossroads--g6.png';
import icon1068 from './warning--crossroads-with-priority-to-the-right--g1.png';
import icon1069 from './warning--curve-left--g1.png';
import icon1070 from './warning--curve-left--g2.png';
import icon1071 from './warning--curve-left--g3.png';
import icon1072 from './warning--curve-left-with-junction--g1.png';
import icon1073 from './warning--curve-out-intersection-left--g1.png';
import icon1074 from './warning--curve-out-intersection-right--g1.png';
import icon1075 from './warning--curve-right--g1.png';
import icon1076 from './warning--curve-right--g2.png';
import icon1077 from './warning--curve-right--g3.png';
import icon1078 from './warning--curve-right-with-junction--g1.png';
import icon1079 from './warning--dangerous-crosswinds-left--g1.png';
import icon1080 from './warning--dangerous-crosswinds-left--g2.png';
import icon1081 from './warning--dangerous-crosswinds-left--g4.png';
import icon1082 from './warning--dangerous-crosswinds-right--g1.png';
import icon1083 from './warning--dangerous-crosswinds-right--g2.png';
import icon1084 from './warning--dangerous-crosswinds-right--g3.png';
import icon1085 from './warning--dangerous-crosswinds-right--g4.png';
import icon1086 from './warning--dead-end--g1.png';
import icon1087 from './warning--dead-end--g2.png';
import icon1088 from './warning--dead-end--g3.png';
import icon1089 from './warning--dead-end-go-left--g1.png';
import icon1090 from './warning--dead-end-go-right--g1.png';
import icon1091 from './warning--descent-or-climbing-lanes-in-triple-lanes--g1.png';
import icon1092 from './warning--detour-ahead--g1.png';
import icon1093 from './warning--detour-or-construction-ahead--g1.png';
import icon1094 from './warning--dip--g1.png';
import icon1095 from './warning--dip--g2.png';
import icon1096 from './warning--disabled-persons-crossing--g1.png';
import icon1097 from './warning--disabled-persons-crossing--g2.png';
import icon1098 from './warning--divided-highway--g1.png';
import icon1099 from './warning--divided-highway--g2.png';
import icon1100 from './warning--divided-highway--g3.png';
import icon1101 from './warning--divided-highway--g4.png';
import icon1102 from './warning--divided-highway--g5.png';
import icon1103 from './warning--divided-highway--g6.png';
import icon1104 from './warning--divided-highway--g7.png';
import icon1105 from './warning--divided-highway--g8.png';
import icon1106 from './warning--divided-highway--g9.png';
import icon1107 from './warning--divided-highway-ends--g1.png';
import icon1108 from './warning--divided-highway-ends--g2.png';
import icon1109 from './warning--divided-highway-ends--g3.png';
import icon1110 from './warning--divided-highway-ends--g4.png';
import icon1111 from './warning--divided-highway-on-left--g1.png';
import icon1112 from './warning--divided-highway-on-left--g2.png';
import icon1113 from './warning--divided-highway-on-right--g1.png';
import icon1114 from './warning--divided-highway-on-right--g2.png';
import icon1115 from './warning--divided-highway-to-left--g1.png';
import icon1116 from './warning--divided-highway-to-right--g1.png';
import icon1117 from './warning--domestic-animals--g1.png';
import icon1118 from './warning--domestic-animals--g2.png';
import icon1119 from './warning--domestic-animals--g3.png';
import icon1120 from './warning--domestic-animals--g4.png';
import icon1121 from './warning--domestic-animals--g5.png';
import icon1122 from './warning--domestic-animals--g6.png';
import icon1123 from './warning--domestic-animals--g7.png';
import icon1124 from './warning--domestic-animals--g8.png';
import icon1125 from './warning--double-curve-first-left--g1.png';
import icon1126 from './warning--double-curve-first-left--g2.png';
import icon1127 from './warning--double-curve-first-right--g1.png';
import icon1128 from './warning--double-curve-first-right--g2.png';
import icon1129 from './warning--double-descent--g1.png';
import icon1130 from './warning--double-reverse-curve-left--g1.png';
import icon1131 from './warning--double-reverse-curve-left--g2.png';
import icon1132 from './warning--double-reverse-curve-right--g1.png';
import icon1133 from './warning--double-reverse-curve-right--g2.png';
import icon1134 from './warning--double-side-roads-left--g1.png';
import icon1135 from './warning--double-side-roads-left--g3.png';
import icon1136 from './warning--double-side-roads-right--g1.png';
import icon1137 from './warning--double-side-roads-right--g3.png';
import icon1138 from './warning--double-turn-first-left--g1.png';
import icon1139 from './warning--double-turn-first-right--g1.png';
import icon1140 from './warning--dual-lanes-all-directions-on-left--g1.png';
import icon1141 from './warning--dual-lanes-all-directions-on-right--g1.png';
import icon1142 from './warning--dual-lanes-go-straight-or-turn-left--g1.png';
import icon1143 from './warning--dual-lanes-go-straight-or-turn-right--g1.png';
import icon1144 from './warning--dual-lanes-left-turn--g1.png';
import icon1145 from './warning--dual-lanes-left-turn-or-go-straight--g1.png';
import icon1146 from './warning--dual-lanes-right-turn--g1.png';
import icon1147 from './warning--dual-lanes-right-turn-or-go-straight--g1.png';
import icon1148 from './warning--dual-lanes-turn-left--g1.png';
import icon1149 from './warning--dual-lanes-turn-left-or-right--g1.png';
import icon1150 from './warning--dual-lanes-turn-left-or-right--g2.png';
import icon1151 from './warning--dual-lanes-turn-left-or-right--g3.png';
import icon1152 from './warning--dual-lanes-turn-left-or-right--g4.png';
import icon1153 from './warning--dual-lanes-turn-right--g1.png';
import icon1154 from './warning--dual-path-cyclists-and-pedestrians--g1.png';
import icon1155 from './warning--electricity--g1.png';
import icon1156 from './warning--electricity--g2.png';
import icon1157 from './warning--elephant-crossing--g1.png';
import icon1158 from './warning--emergency-vehicles--g1.png';
import icon1159 from './warning--emu-crossing--g1.png';
import icon1160 from './warning--emu-crossing--g2.png';
import icon1161 from './warning--entering-roadway-merge--g1.png';
import icon1162 from './warning--entering-roadway-merge--g2.png';
import icon1163 from './warning--equestrians-crossing--g1.png';
import icon1164 from './warning--equestrians-crossing--g2.png';
import icon1165 from './warning--expressway--g1.png';
import icon1166 from './warning--falling-rocks-or-debris-left--g1.png';
import icon1167 from './warning--falling-rocks-or-debris-left--g2.png';
import icon1168 from './warning--falling-rocks-or-debris-left--g3.png';
import icon1169 from './warning--falling-rocks-or-debris-left--g4.png';
import icon1170 from './warning--falling-rocks-or-debris-right--g1.png';
import icon1171 from './warning--falling-rocks-or-debris-right--g2.png';
import icon1172 from './warning--falling-rocks-or-debris-right--g3.png';
import icon1173 from './warning--falling-rocks-or-debris-right--g4.png';
import icon1174 from './warning--ferry--g1.png';
import icon1175 from './warning--flaggers-in-road--g1.png';
import icon1176 from './warning--flaggers-in-road--g2.png';
import icon1177 from './warning--foggy-road--g1.png';
import icon1178 from './warning--foggy-road--g2.png';
import icon1179 from './warning--ford--g1.png';
import icon1180 from './warning--forest--g1.png';
import icon1181 from './warning--fresh-oil--g1.png';
import icon1182 from './warning--frog-crossing--g1.png';
import icon1183 from './warning--gate--g1.png';
import icon1184 from './warning--gate--g2.png';
import icon1185 from './warning--gate-left--g1.png';
import icon1186 from './warning--gate-right--g1.png';
import icon1187 from './warning--go-left--g1.png';
import icon1188 from './warning--go-right--g1.png';
import icon1189 from './warning--golf-carts-crossing--g1.png';
import icon1190 from './warning--gravel-road-surface--g1.png';
import icon1191 from './warning--hairpin-curve-left--g1.png';
import icon1192 from './warning--hairpin-curve-left--g2.png';
import icon1193 from './warning--hairpin-curve-left--g3.png';
import icon1194 from './warning--hairpin-curve-right--g1.png';
import icon1195 from './warning--hairpin-curve-right--g3.png';
import icon1196 from './warning--height-restriction--g2.png';
import icon1197 from './warning--height-restriction--g3.png';
import icon1198 from './warning--height-restriction--g4.png';
import icon1199 from './warning--height-restriction--g5.png';
import icon1200 from './warning--horizontal-alignment-left--g1.png';
import icon1201 from './warning--horizontal-alignment-left--g3.png';
import icon1202 from './warning--horizontal-alignment-right--g1.png';
import icon1203 from './warning--horizontal-alignment-right--g3.png';
import icon1204 from './warning--horse-crossing--g1.png';
import icon1205 from './warning--icy-road--g1.png';
import icon1206 from './warning--junction-with-a-side-road-acute-left--g1.png';
import icon1207 from './warning--junction-with-a-side-road-acute-left--g2.png';
import icon1208 from './warning--junction-with-a-side-road-acute-right--g1.png';
import icon1209 from './warning--junction-with-a-side-road-acute-right--g2.png';
import icon1210 from './warning--junction-with-a-side-road-perpendicular-left--g1.png';
import icon1211 from './warning--junction-with-a-side-road-perpendicular-left--g2.png';
import icon1212 from './warning--junction-with-a-side-road-perpendicular-left--g3.png';
import icon1213 from './warning--junction-with-a-side-road-perpendicular-left--g4.png';
import icon1214 from './warning--junction-with-a-side-road-perpendicular-right--g1.png';
import icon1215 from './warning--junction-with-a-side-road-perpendicular-right--g2.png';
import icon1216 from './warning--junction-with-a-side-road-perpendicular-right--g3.png';
import icon1217 from './warning--junction-with-a-side-road-perpendicular-right--g4.png';
import icon1218 from './warning--junction-with-merge-from-left--g1.png';
import icon1219 from './warning--junction-with-merge-from-right--g1.png';
import icon1220 from './warning--junction-with-side-roads--g1.png';
import icon1221 from './warning--kangaloo-crossing--g1.png';
import icon1222 from './warning--keep-distance--g1.png';
import icon1223 from './warning--keep-left--g1.png';
import icon1224 from './warning--keep-right--g1.png';
import icon1225 from './warning--kiwi-crossing--g1.png';
import icon1226 from './warning--kiwi-crossing--g2.png';
import icon1227 from './warning--koala-crossing--g1.png';
import icon1228 from './warning--koala-crossing--g2.png';
import icon1229 from './warning--koala-crossing--g3.png';
import icon1230 from './warning--koala-crossing--g4.png';
import icon1231 from './warning--lane-closed-in-dual-lanes-left--g1.png';
import icon1232 from './warning--lane-closed-in-dual-lanes-left--g2.png';
import icon1233 from './warning--lane-closed-in-dual-lanes-right--g1.png';
import icon1234 from './warning--lane-closed-in-dual-lanes-right--g2.png';
import icon1235 from './warning--length-restriction--g1.png';
import icon1236 from './warning--length-restriction--g2.png';
import icon1237 from './warning--light-rail-transit-vehicles--g1.png';
import icon1238 from './warning--limited-lighting-under-trees--g1.png';
import icon1239 from './warning--logging-vehicles--g1.png';
import icon1240 from './warning--loop-270-degree--g1.png';
import icon1241 from './warning--loop-pretzel--g1.png';
import icon1242 from './warning--loose-road-surface--g1.png';
import icon1243 from './warning--loose-road-surface--g2.png';
import icon1244 from './warning--loose-road-surface--g3.png';
import icon1245 from './warning--loose-road-surface--g4.png';
import icon1246 from './warning--low-flying-aircraft--g1.png';
import icon1247 from './warning--low-flying-aircraft--g2.png';
import icon1248 from './warning--low-flying-aircraft--g3.png';
import icon1249 from './warning--low-flying-aircraft--g4.png';
import icon1250 from './warning--low-flying-aircraft--g5.png';
import icon1251 from './warning--low-flying-aircraft--g6.png';
import icon1252 from './warning--low-flying-aircraft--g7.png';
import icon1253 from './warning--low-flying-aircraft--g8.png';
import icon1254 from './warning--low-ground-clearance--g1.png';
import icon1255 from './warning--low-ground-clearance--g2.png';
import icon1256 from './warning--low-ground-clearance--g3.png';
import icon1257 from './warning--monkey-crossing--g1.png';
import icon1258 from './warning--motorcycles-crossing--g1.png';
import icon1259 from './warning--narrow-bridge--g1.png';
import icon1260 from './warning--narrow-bridge--g2.png';
import icon1261 from './warning--narrow-bridge--g3.png';
import icon1262 from './warning--no-passing-zone--g1.png';
import icon1263 from './warning--no-passing-zone--g2.png';
import icon1264 from './warning--occupied-lanes--g1.png';
import icon1265 from './warning--offset-roads--g1.png';
import icon1266 from './warning--offset-roads--g2.png';
import icon1267 from './warning--offset-roads--g3.png';
import icon1268 from './warning--offset-roads--g4.png';
import icon1269 from './warning--opening-or-swing-bridge--g1.png';
import icon1270 from './warning--opening-or-swing-bridge--g2.png';
import icon1271 from './warning--other-danger--g1.png';
import icon1272 from './warning--other-danger--g2.png';
import icon1273 from './warning--other-danger--g3.png';
import icon1274 from './warning--panda-crossing--g1.png';
import icon1275 from './warning--pass-left-or-right--g1.png';
import icon1276 from './warning--pass-left-or-right--g2.png';
import icon1277 from './warning--pass-left-or-right--g3.png';
import icon1278 from './warning--pavement-ahead--g1.png';
import icon1279 from './warning--pavement-ends--g1.png';
import icon1280 from './warning--pavement-ends--g2.png';
import icon1281 from './warning--pavement-ends--g3.png';
import icon1282 from './warning--pavement-ends--g4.png';
import icon1283 from './warning--pavement-ends--g5.png';
import icon1284 from './warning--pedestrians-crossing--g1.png';
import icon1285 from './warning--pedestrians-crossing--g4.png';
import icon1286 from './warning--pedestrians-crossing--g5.png';
import icon1287 from './warning--pedestrians-crossing--g6.png';
import icon1288 from './warning--pedestrians-crossing--g7.png';
import icon1289 from './warning--pedestrians-crossing--g8.png';
import icon1290 from './warning--pedestrians-crossing--g9.png';
import icon1291 from './warning--pedestrians-crossing--g10.png';
import icon1292 from './warning--pedestrians-crossing--g11.png';
import icon1293 from './warning--pedestrians-crossing--g12.png';
import icon1294 from './warning--playground--g1.png';
import icon1295 from './warning--playground--g3.png';
import icon1296 from './warning--polar-bear-crossing--g1.png';
import icon1297 from './warning--quay-or-river-bank--g1.png';
import icon1298 from './warning--quay-or-river-bank--g2.png';
import icon1299 from './warning--quay-or-river-bank--g3.png';
import icon1300 from './warning--quay-or-river-bank--g4.png';
import icon1301 from './warning--rabbit-crossing--g1.png';
import icon1302 from './warning--raccoon-crossing--g1.png';
import icon1303 from './warning--railroad-crossing--g1.png';
import icon1304 from './warning--railroad-crossing--g2.png';
import icon1305 from './warning--railroad-crossing--g3.png';
import icon1306 from './warning--railroad-crossing--g4.png';
import icon1307 from './warning--railroad-crossing-with-barriers--g1.png';
import icon1308 from './warning--railroad-crossing-with-barriers--g2.png';
import icon1309 from './warning--railroad-crossing-with-barriers--g3.png';
import icon1310 from './warning--railroad-crossing-with-barriers--g4.png';
import icon1311 from './warning--railroad-crossing-with-barriers--g5.png';
import icon1312 from './warning--railroad-crossing-with-barriers--g6.png';
import icon1313 from './warning--railroad-crossing-with-barriers--g7.png';
import icon1314 from './warning--railroad-crossing-without-barriers--g1.png';
import icon1315 from './warning--railroad-crossing-without-barriers--g2.png';
import icon1316 from './warning--railroad-crossing-without-barriers--g3.png';
import icon1317 from './warning--railroad-crossing-without-barriers--g4.png';
import icon1318 from './warning--railroad-crossing-without-barriers--g5.png';
import icon1319 from './warning--railroad-crossing-without-barriers--g6.png';
import icon1320 from './warning--railroad-intersection--g1.png';
import icon1321 from './warning--railroad-intersection--g2.png';
import icon1322 from './warning--railroad-intersection--g3.png';
import icon1323 from './warning--railroad-intersection--g4.png';
import icon1324 from './warning--railroad-intersection--g5.png';
import icon1325 from './warning--railroad-intersection--g6.png';
import icon1326 from './warning--railroad-intersection--g7.png';
import icon1327 from './warning--railroad-intersection--g8.png';
import icon1328 from './warning--railroad-intersection--g9.png';
import icon1329 from './warning--ramp-closed--g1.png';
import icon1330 from './warning--reduced-maximum-speed-limit--g1.png';
import icon1331 from './warning--reserved-lane--g1.png';
import icon1332 from './warning--restricted-zone--g1.png';
import icon1333 from './warning--reversible-lanes--g1.png';
import icon1334 from './warning--reversible-lanes--g2.png';
import icon1335 from './warning--rickshaws-crossing--g1.png';
import icon1336 from './warning--road-blocks--g1.png';
import icon1337 from './warning--road-bump--g1.png';
import icon1338 from './warning--road-bump--g2.png';
import icon1339 from './warning--road-bump--g3.png';
import icon1340 from './warning--road-bump-with-speed-limit--g1.png';
import icon1341 from './warning--road-closed--g3.png';
import icon1342 from './warning--road-narrows--g1.png';
import icon1343 from './warning--road-narrows--g2.png';
import icon1344 from './warning--road-narrows-left--g1.png';
import icon1345 from './warning--road-narrows-left--g2.png';
import icon1346 from './warning--road-narrows-left-ahead--g1.png';
import icon1347 from './warning--road-narrows-right--g1.png';
import icon1348 from './warning--road-narrows-right--g2.png';
import icon1349 from './warning--road-narrows-right-ahead--g1.png';
import icon1350 from './warning--road-toll-ahead--g1.png';
import icon1351 from './warning--road-widens--g1.png';
import icon1352 from './warning--road-widens-left--g1.png';
import icon1353 from './warning--road-widens-right--g1.png';
import icon1354 from './warning--roadworks--g1.png';
import icon1355 from './warning--roadworks--g2.png';
import icon1356 from './warning--roadworks--g3.png';
import icon1357 from './warning--roadworks--g5.png';
import icon1358 from './warning--roadworks--g6.png';
import icon1359 from './warning--roadworks--g8.png';
import icon1360 from './warning--roadworks--g9.png';
import icon1361 from './warning--roadworks--g10.png';
import icon1362 from './warning--roadworks--g11.png';
import icon1363 from './warning--roadworks-go-left-or-straight--g1.png';
import icon1364 from './warning--roadworks-go-right-or-straight--g1.png';
import icon1365 from './warning--roundabout--g1.png';
import icon1366 from './warning--roundabout--g2.png';
import icon1367 from './warning--roundabout--g3.png';
import icon1368 from './warning--roundabout--g4.png';
import icon1369 from './warning--roundabout--g5.png';
import icon1370 from './warning--roundabout--g6.png';
import icon1371 from './warning--roundabout--g7.png';
import icon1372 from './warning--ruts--g1.png';
import icon1373 from './warning--sand--g1.png';
import icon1374 from './warning--sand-drift--g1.png';
import icon1375 from './warning--school-zone--g2.png';
import icon1376 from './warning--severe-weather--g1.png';
import icon1377 from './warning--shared-lane-motorcycles-bicycles--g1.png';
import icon1378 from './warning--sharp-turn--g1.png';
import icon1379 from './warning--single-reverse-curve--g1.png';
import icon1380 from './warning--skewed-t-roads-left--g1.png';
import icon1381 from './warning--skewed-t-roads-left--g2.png';
import icon1382 from './warning--skewed-t-roads-left--g3.png';
import icon1383 from './warning--skewed-t-roads-right--g1.png';
import icon1384 from './warning--skewed-t-roads-right--g2.png';
import icon1385 from './warning--skewed-t-roads-right--g3.png';
import icon1386 from './warning--skiers--g1.png';
import icon1387 from './warning--skiers--g2.png';
import icon1388 from './warning--skiers--g3.png';
import icon1389 from './warning--slippery-bicycles--g1.png';
import icon1390 from './warning--slippery-motorcycles--g1.png';
import icon1391 from './warning--slippery-motorcycles--g2.png';
import icon1392 from './warning--slippery-road-surface--g1.png';
import icon1393 from './warning--slippery-road-surface--g2.png';
import icon1394 from './warning--slow--g1.png';
import icon1395 from './warning--snow-tractors--g1.png';
import icon1396 from './warning--snowmobiles--g1.png';
import icon1397 from './warning--snowmobiles--g2.png';
import icon1398 from './warning--snowmobiles--g3.png';
import icon1399 from './warning--snowmobiles-and-others--g1.png';
import icon1400 from './warning--soft-road-surface--g1.png';
import icon1401 from './warning--soft-road-surface--g2.png';
import icon1402 from './warning--soft-shoulder--g1.png';
import icon1403 from './warning--soft-shoulder--g2.png';
import icon1404 from './warning--soft-shoulder--g3.png';
import icon1405 from './warning--soft-shoulder--g4.png';
import icon1406 from './warning--speed-camera--g1.png';
import icon1407 from './warning--steep-ascent--g1.png';
import icon1408 from './warning--steep-ascent--g2.png';
import icon1409 from './warning--steep-ascent--g3.png';
import icon1410 from './warning--steep-ascent--g4.png';
import icon1411 from './warning--steep-ascent-and-descent--g1.png';
import icon1412 from './warning--steep-descent--g1.png';
import icon1413 from './warning--steep-descent--g2.png';
import icon1414 from './warning--steep-descent--g3.png';
import icon1415 from './warning--steep-descent--g4.png';
import icon1416 from './warning--steep-descent--g5.png';
import icon1417 from './warning--steep-descent--g6.png';
import icon1418 from './warning--stop-ahead--g1.png';
import icon1419 from './warning--stop-ahead--g3.png';
import icon1420 from './warning--stop-ahead--g4.png';
import icon1421 from './warning--stop-ahead--g5.png';
import icon1422 from './warning--stop-ahead--g6.png';
import icon1423 from './warning--t-roads--g1.png';
import icon1424 from './warning--t-roads--g2.png';
import icon1425 from './warning--tanks-crossing--g1.png';
import icon1426 from './warning--tanks-crossing--g2.png';
import icon1427 from './warning--texts--g1.png';
import icon1428 from './warning--texts--g2.png';
import icon1429 from './warning--texts--g3.png';
import icon1430 from './warning--towing--g1.png';
import icon1431 from './warning--tractors--g1.png';
import icon1432 from './warning--tractors--g2.png';
import icon1433 from './warning--tractors--g3.png';
import icon1434 from './warning--tractors--g4.png';
import icon1435 from './warning--tractors--g5.png';
import icon1436 from './warning--tractors--g6.png';
import icon1437 from './warning--tractors--g7.png';
import icon1438 from './warning--traffic-merges-at-signalized-intersections--g1.png';
import icon1439 from './warning--traffic-merges-left--g1.png';
import icon1440 from './warning--traffic-merges-left--g2.png';
import icon1441 from './warning--traffic-merges-left--g3.png';
import icon1442 from './warning--traffic-merges-left--g4.png';
import icon1443 from './warning--traffic-merges-left-and-right--g1.png';
import icon1444 from './warning--traffic-merges-left-buses--g1.png';
import icon1445 from './warning--traffic-merges-right--g1.png';
import icon1446 from './warning--traffic-merges-right--g2.png';
import icon1447 from './warning--traffic-merges-right--g3.png';
import icon1448 from './warning--traffic-merges-right-buses--g1.png';
import icon1449 from './warning--traffic-queues-likely--g1.png';
import icon1450 from './warning--traffic-queues-likely--g2.png';
import icon1451 from './warning--traffic-queues-likely--g3.png';
import icon1452 from './warning--traffic-queues-likely--g4.png';
import icon1453 from './warning--traffic-queues-likely--g5.png';
import icon1454 from './warning--traffic-signals--g1.png';
import icon1455 from './warning--traffic-signals--g2.png';
import icon1456 from './warning--traffic-signals--g3.png';
import icon1457 from './warning--traffic-signals--g4.png';
import icon1458 from './warning--traffic-signals--g5.png';
import icon1459 from './warning--traffic-signals--g6.png';
import icon1460 from './warning--traffic-slow--g1.png';
import icon1461 from './warning--trail-crossing--g1.png';
import icon1462 from './warning--trail-crossing--g2.png';
import icon1463 from './warning--trail-crossing--g3.png';
import icon1464 from './warning--trail-crossing--g4.png';
import icon1465 from './warning--trail-crossing--g5.png';
import icon1466 from './warning--trail-crossing--g6.png';
import icon1467 from './warning--trams-crossing--g1.png';
import icon1468 from './warning--trams-crossing--g2.png';
import icon1469 from './warning--triple-curve-left--g1.png';
import icon1470 from './warning--triple-curve-right--g1.png';
import icon1471 from './warning--triple-lanes-left-turn--g1.png';
import icon1472 from './warning--triple-lanes-left-turn-or-go-straight--g1.png';
import icon1473 from './warning--triple-lanes-right-turn--g1.png';
import icon1474 from './warning--triple-lanes-right-turn-or-go-straight--g1.png';
import icon1475 from './warning--triple-lanes-with-directions--g1.png';
import icon1476 from './warning--triple-reverse-curve-left--g1.png';
import icon1477 from './warning--triple-reverse-curve-right--g1.png';
import icon1478 from './warning--trucks-crossing--g1.png';
import icon1479 from './warning--trucks-crossing--g2.png';
import icon1480 from './warning--trucks-rollover--g1.png';
import icon1481 from './warning--trucks-rollover--g2.png';
import icon1482 from './warning--trucks-rollover--g3.png';
import icon1483 from './warning--trucks-rollover--g4.png';
import icon1484 from './warning--trucks-rollover--g5.png';
import icon1485 from './warning--tunnel--g1.png';
import icon1486 from './warning--tunnel--g2.png';
import icon1487 from './warning--tunnel--g3.png';
import icon1488 from './warning--tunnel--g4.png';
import icon1489 from './warning--tunnel--g5.png';
import icon1490 from './warning--tunnel--g6.png';
import icon1491 from './warning--tunnel--g7.png';
import icon1492 from './warning--turn-left--g1.png';
import icon1493 from './warning--turn-left--g2.png';
import icon1494 from './warning--turn-left--g3.png';
import icon1495 from './warning--turn-left-or-right--g1.png';
import icon1496 from './warning--turn-right--g1.png';
import icon1497 from './warning--turn-right--g2.png';
import icon1498 from './warning--turn-right--g3.png';
import icon1499 from './warning--two-way-traffic--g1.png';
import icon1500 from './warning--two-way-traffic--g2.png';
import icon1501 from './warning--two-way-traffic--g3.png';
import icon1502 from './warning--two-way-traffic--g4.png';
import icon1503 from './warning--two-way-traffic--g5.png';
import icon1504 from './warning--two-way-traffic--g6.png';
import icon1505 from './warning--u-turn--g1.png';
import icon1506 from './warning--u-turn--g2.png';
import icon1507 from './warning--uneven-road--g1.png';
import icon1508 from './warning--uneven-road--g2.png';
import icon1509 from './warning--uneven-roads-ahead--g1.png';
import icon1510 from './warning--vehicles-and-others--g1.png';
import icon1511 from './warning--vehicles-crossing--g1.png';
import icon1512 from './warning--village--g1.png';
import icon1513 from './warning--weight-limit--g5.png';
import icon1514 from './warning--weight-limit-per-tandem-axle--g1.png';
import icon1515 from './warning--width-restriction--g1.png';
import icon1516 from './warning--width-restriction--g2.png';
import icon1517 from './warning--width-restriction--g3.png';
import icon1518 from './warning--width-restriction--g4.png';
import icon1519 from './warning--wild-animals--g1.png';
import icon1520 from './warning--wild-animals--g2.png';
import icon1521 from './warning--wild-animals--g3.png';
import icon1522 from './warning--wild-animals--g4.png';
import icon1523 from './warning--wild-animals--g5.png';
import icon1524 from './warning--wild-animals--g6.png';
import icon1525 from './warning--wild-animals--g7.png';
import icon1526 from './warning--wild-animals--g8.png';
import icon1527 from './warning--wind--g1.png';
import icon1528 from './warning--winding-road--g1.png';
import icon1529 from './warning--winding-road-first-left--g1.png';
import icon1530 from './warning--winding-road-first-left--g2.png';
import icon1531 from './warning--winding-road-first-left--g3.png';
import icon1532 from './warning--winding-road-first-right--g1.png';
import icon1533 from './warning--winding-road-first-right--g2.png';
import icon1534 from './warning--winding-road-first-right--g3.png';
import icon1535 from './warning--winding-road-first-right--g4.png';
import icon1536 from './warning--winding-road-to-left--g1.png';
import icon1537 from './warning--winding-road-to-right--g1.png';
import icon1538 from './warning--wombat-crossing--g1.png';
import icon1539 from './warning--y-roads--g1.png';
import icon1540 from './warning--y-roads--g2.png';
import icon1541 from './warning--yield-ahead--g1.png';
import icon1542 from './warning--yield-ahead--g3.png';

const textures = {
  'complementary--accident-area--g1': icon0,
  'complementary--accident-area--g2': icon1,
  'complementary--accident-area--g3': icon2,
  'complementary--accident-area--g4': icon3,
  'complementary--advisory-exit-or-ramp-speed--g1': icon4,
  'complementary--bicycles--g1': icon5,
  'complementary--bicycles-and-pedestrians-detour--g1': icon6,
  'complementary--bicycles-or-pedestrians-detour--g1': icon7,
  'complementary--bicycles-turn-right--g1': icon8,
  'complementary--bike-route--g1': icon9,
  'complementary--bike-route--g3': icon10,
  'complementary--both-directions--g1': icon11,
  'complementary--both-directions--g2': icon12,
  'complementary--buses--g1': icon13,
  'complementary--buses-and-trucks--g1': icon14,
  'complementary--camera--g1': icon15,
  'complementary--camera--g2': icon16,
  'complementary--camera--g3': icon17,
  'complementary--camera--g4': icon18,
  'complementary--camera--g5': icon19,
  'complementary--caravan-trailers--g2': icon20,
  'complementary--caravan-trailers--g3': icon21,
  'complementary--caravans--g2': icon22,
  'complementary--carts--g1': icon23,
  'complementary--chevron-left--g1': icon24,
  'complementary--chevron-left--g2': icon25,
  'complementary--chevron-left--g3': icon26,
  'complementary--chevron-left--g4': icon27,
  'complementary--chevron-left--g5': icon28,
  'complementary--chevron-right--g1': icon29,
  'complementary--chevron-right--g2': icon30,
  'complementary--chevron-right--g3': icon31,
  'complementary--chevron-right--g4': icon32,
  'complementary--chevron-right--g5': icon33,
  'complementary--dangerous-or-pollutant-good--g1': icon34,
  'complementary--dead-end--g1': icon35,
  'complementary--detour--g1': icon36,
  'complementary--disabled-persons--g1': icon37,
  'complementary--distance--g1': icon38,
  'complementary--distance--g2': icon39,
  'complementary--distance--g3': icon40,
  'complementary--end-of-road-works--g1': icon41,
  'complementary--except-bicycles--g1': icon42,
  'complementary--except-bicycles--g2': icon43,
  'complementary--except-buses--g1': icon44,
  'complementary--except-carts--g1': icon45,
  'complementary--except-motorcycles--g1': icon46,
  'complementary--except-motorcycles--g2': icon47,
  'complementary--except-polluting-level-green--g1': icon48,
  'complementary--except-polluting-level-green-yellow--g1': icon49,
  'complementary--except-polluting-level-green-yellow-red--g1': icon50,
  'complementary--except-tractors--g1': icon51,
  'complementary--except-tractors--g2': icon52,
  'complementary--except-trailers--g1': icon53,
  'complementary--except-trailers--g2': icon54,
  'complementary--except-trains--g1': icon55,
  'complementary--except-trams--g1': icon56,
  'complementary--except-trucks--g1': icon57,
  'complementary--except-vehicles--g1': icon58,
  'complementary--except-vehicles--g2': icon59,
  'complementary--go-left--g1': icon60,
  'complementary--go-right--g1': icon61,
  'complementary--go-straight-or-turn-left--g1': icon62,
  'complementary--go-straight-or-turn-right--g1': icon63,
  'complementary--height-limit--g1': icon64,
  'complementary--height-limit--g2': icon65,
  'complementary--including-bicycles-and-motorcycles--g1': icon66,
  'complementary--including-buses-vehicles--g1': icon67,
  'complementary--keep-left--g1': icon68,
  'complementary--keep-right--g1': icon69,
  'complementary--lane-control--g1': icon70,
  'complementary--lane-control--g2': icon71,
  'complementary--lane-control--g3': icon72,
  'complementary--maximum-speed-limit-10--g1': icon73,
  'complementary--maximum-speed-limit-15--g1': icon74,
  'complementary--maximum-speed-limit-20--g1': icon75,
  'complementary--maximum-speed-limit-25--g1': icon76,
  'complementary--maximum-speed-limit-30--g1': icon77,
  'complementary--maximum-speed-limit-35--g1': icon78,
  'complementary--maximum-speed-limit-40--g1': icon79,
  'complementary--maximum-speed-limit-45--g1': icon80,
  'complementary--maximum-speed-limit-50--g1': icon81,
  'complementary--maximum-speed-limit-55--g1': icon82,
  'complementary--maximum-speed-limit-60--g1': icon83,
  'complementary--maximum-speed-limit-65--g1': icon84,
  'complementary--maximum-speed-limit-70--g1': icon85,
  'complementary--maximum-speed-limit-75--g1': icon86,
  'complementary--maximum-speed-limit-80--g1': icon87,
  'complementary--maximum-speed-limit-85--g1': icon88,
  'complementary--maximum-speed-limit-90--g1': icon89,
  'complementary--maximum-speed-limit-95--g1': icon90,
  'complementary--motorcycles--g1': icon91,
  'complementary--motorcycles--g2': icon92,
  'complementary--motorcycles--g3': icon93,
  'complementary--motorcycles--g4': icon94,
  'complementary--obstacle-delineator--g1': icon95,
  'complementary--obstacle-delineator--g2': icon96,
  'complementary--obstacle-delineator--g3': icon97,
  'complementary--one-direction-left--g1': icon98,
  'complementary--one-direction-right--g1': icon99,
  'complementary--pass-left--g1': icon100,
  'complementary--pass-right--g1': icon101,
  'complementary--pedestrians-and-bicycles--g1': icon102,
  'complementary--pedestrians-left--g1': icon103,
  'complementary--pedestrians-right--g1': icon104,
  'complementary--photo-enforced--g1': icon105,
  'complementary--playground--g1': icon106,
  'complementary--priority-route-at-intersection--g1': icon107,
  'complementary--priority-route-at-intersection--g2': icon108,
  'complementary--priority-route-at-intersection--g3': icon109,
  'complementary--priority-route-at-intersection--g4': icon110,
  'complementary--priority-route-at-intersection--g5': icon111,
  'complementary--priority-route-at-intersection--g6': icon112,
  'complementary--railroad--g1': icon113,
  'complementary--railroad--g2': icon114,
  'complementary--railroad--g3': icon115,
  'complementary--restriction-in-both-directions--g1': icon116,
  'complementary--roundabout-go-left--g1': icon117,
  'complementary--roundabout-go-right--g1': icon118,
  'complementary--roundabout-go-straight--g1': icon119,
  'complementary--slippery-for-caravan-trailers--g1': icon120,
  'complementary--snow--g2': icon121,
  'complementary--snow--g4': icon122,
  'complementary--snow--g5': icon123,
  'complementary--snowmobiles--g1': icon124,
  'complementary--soft-shoulder--g1': icon125,
  'complementary--soft-shoulder--g2': icon126,
  'complementary--steep-ascent--g1': icon127,
  'complementary--steep-descent--g1': icon128,
  'complementary--time-restrictions--g1': icon129,
  'complementary--time-restrictions--g3': icon130,
  'complementary--tow-away-zone--g1': icon131,
  'complementary--tow-away-zone--g3': icon132,
  'complementary--tractors--g1': icon133,
  'complementary--traffic-queues--g1': icon134,
  'complementary--trailers--g1': icon135,
  'complementary--trailers--g2': icon136,
  'complementary--trailers--g3': icon137,
  'complementary--trailers--g4': icon138,
  'complementary--trains--g1': icon139,
  'complementary--trams--g1': icon140,
  'complementary--trees--g1': icon141,
  'complementary--trucks--g1': icon142,
  'complementary--trucks--g2': icon143,
  'complementary--trucks--g3': icon144,
  'complementary--trucks-and-trailers--g1': icon145,
  'complementary--trucks-buses-trailers--g1': icon146,
  'complementary--trucks-go-left--g1': icon147,
  'complementary--trucks-go-left-ahead--g1': icon148,
  'complementary--trucks-go-right--g1': icon149,
  'complementary--trucks-go-right-ahead--g1': icon150,
  'complementary--trucks-go-straight--g1': icon151,
  'complementary--trucks-turn-left--g1': icon152,
  'complementary--trucks-turn-right--g1': icon153,
  'complementary--turn-left--g1': icon154,
  'complementary--turn-left--g2': icon155,
  'complementary--turn-right--g1': icon156,
  'complementary--turn-right--g2': icon157,
  'complementary--two-way-traffic--g1': icon158,
  'complementary--two-way-traffic--g2': icon159,
  'complementary--two-way-traffic--g3': icon160,
  'complementary--two-way-traffic--g4': icon161,
  'complementary--two-way-traffic--g5': icon162,
  'complementary--vehicles--g1': icon163,
  'complementary--vehicles--g2': icon164,
  'complementary--vehicles-or-buses--g1': icon165,
  'complementary--weekends-or-holidays--g1': icon166,
  'complementary--weight-limit--g1': icon167,
  'complementary--when-foggy--g1': icon168,
  'complementary--when-rainy--g1': icon169,
  'complementary--when-rainy--g2': icon170,
  'complementary--when-rainy--g3': icon171,
  'complementary--when-snowy--g1': icon172,
  'complementary--when-snowy--g2': icon173,
  'complementary--when-snowy-or-rainy--g1': icon174,
  'complementary--when-snowy-or-rainy--g2': icon175,
  'complementary--when-wet--g1': icon176,
  'complementary--width-limit--g1': icon177,
  'complementary--working-days--g1': icon178,
  'information--airport--g1': icon179,
  'information--airport--g2': icon180,
  'information--bicycle-lane--g1': icon181,
  'information--bicycles-both-ways--g1': icon182,
  'information--bicycles-crossing--g1': icon183,
  'information--bicycles-crossing--g2': icon184,
  'information--bicycles-crossing--g3': icon185,
  'information--bike-route--g1': icon186,
  'information--bike-route--g2': icon187,
  'information--built-up-area--g1': icon188,
  'information--built-up-area--g2': icon189,
  'information--bus-lane-straight--g1': icon190,
  'information--bus-stop--g1': icon191,
  'information--bus-stop--g2': icon192,
  'information--camera--g1': icon193,
  'information--camera--g2': icon194,
  'information--camera--g3': icon195,
  'information--camp--g1': icon196,
  'information--camp--g2': icon197,
  'information--car-pool-lane--g1': icon198,
  'information--caravan-parking--g1': icon199,
  'information--caravan-trailer-parking--g1': icon200,
  'information--cargo-loading-zone--g1': icon201,
  'information--central-lane--g1': icon202,
  'information--charging-station--g1': icon203,
  'information--children--g1': icon204,
  'information--children--g2': icon205,
  'information--children-crossing--g5': icon206,
  'information--cycling-two-abreast-permitted--g1': icon207,
  'information--dead-end--g1': icon208,
  'information--dead-end--g2': icon209,
  'information--dead-end--g3': icon210,
  'information--dead-end--g4': icon211,
  'information--dead-end-except-bicycles--g1': icon212,
  'information--dead-end-except-bicycles-and-pedestrians--g1': icon213,
  'information--dead-end-except-bicycles-and-pedestrians--g2': icon214,
  'information--dead-end-left--g1': icon215,
  'information--dead-end-left--g2': icon216,
  'information--dead-end-right--g1': icon217,
  'information--dead-end-right--g2': icon218,
  'information--dead-end-right--g3': icon219,
  'information--directions--g1': icon220,
  'information--disabled-persons--g1': icon221,
  'information--disabled-persons--g2': icon222,
  'information--disabled-persons--g3': icon223,
  'information--emergency-facility--g1': icon224,
  'information--end-of-advisory-maximum-speed-limit-20--g1': icon225,
  'information--end-of-advisory-maximum-speed-limit-40--g1': icon226,
  'information--end-of-advisory-maximum-speed-limit-60--g1': icon227,
  'information--end-of-advisory-maximum-speed-limit-70--g1': icon228,
  'information--end-of-advisory-maximum-speed-limit-80--g1': icon229,
  'information--end-of-advisory-maximum-speed-limit-90--g1': icon230,
  'information--end-of-bicycle-lane--g1': icon231,
  'information--end-of-built-up-area--g1': icon232,
  'information--end-of-built-up-area--g2': icon233,
  'information--end-of-built-up-area--g3': icon234,
  'information--end-of-built-up-area--g4': icon235,
  'information--end-of-car-pool-lane--g1': icon236,
  'information--end-of-limited-access-road--g1': icon237,
  'information--end-of-living-street--g1': icon238,
  'information--end-of-living-street--g2': icon239,
  'information--end-of-minimum-speed-10--g1': icon240,
  'information--end-of-minimum-speed-20--g1': icon241,
  'information--end-of-minimum-speed-25--g1': icon242,
  'information--end-of-minimum-speed-30--g1': icon243,
  'information--end-of-minimum-speed-35--g1': icon244,
  'information--end-of-minimum-speed-40--g1': icon245,
  'information--end-of-minimum-speed-50--g1': icon246,
  'information--end-of-minimum-speed-60--g1': icon247,
  'information--end-of-minimum-speed-70--g1': icon248,
  'information--end-of-minimum-speed-75--g1': icon249,
  'information--end-of-minimum-speed-80--g1': icon250,
  'information--end-of-minimum-speed-90--g1': icon251,
  'information--end-of-minimum-speed-100--g1': icon252,
  'information--end-of-minimum-speed-110--g1': icon253,
  'information--end-of-minimum-speed-120--g1': icon254,
  'information--end-of-minimum-speed-130--g1': icon255,
  'information--end-of-motorway--g1': icon256,
  'information--end-of-overtaking-permitted-heavy-good-vehicles--g1': icon257,
  'information--end-of-road-works--g1': icon258,
  'information--end-of-tunnel--g1': icon259,
  'information--end-of-tunnel--g2': icon260,
  'information--end-of-two-way-traffic--g1': icon261,
  'information--equestrians-permitted--g1': icon262,
  'information--exit-ahead--g1': icon263,
  'information--exit-ahead--g2': icon264,
  'information--exit-ahead--g3': icon265,
  'information--flight-port--g1': icon266,
  'information--food--g1': icon267,
  'information--food--g2': icon268,
  'information--gas-station--g1': icon269,
  'information--gas-station--g2': icon270,
  'information--gas-station--g3': icon271,
  'information--general-speed-limit-at-city-border--g1': icon272,
  'information--go-left--g1': icon273,
  'information--go-right--g1': icon274,
  'information--go-straight--g1': icon275,
  'information--go-straight-or-left--g1': icon276,
  'information--go-straight-or-right--g1': icon277,
  'information--go-straight-or-turn-left--g1': icon278,
  'information--go-straight-or-turn-right--g1': icon279,
  'information--hazardous-goods-vehicles-lane--g1': icon280,
  'information--height-limit--g1': icon281,
  'information--height-limit--g2': icon282,
  'information--highway-directions--g1': icon283,
  'information--highway-exit--g1': icon284,
  'information--highway-interchange--g1': icon285,
  'information--highway-interstate-route--g1': icon286,
  'information--highway-interstate-route--g2': icon287,
  'information--highway-preferential-lane--g1': icon288,
  'information--highway-preferential-lane--g2': icon289,
  'information--highway-reference-location--g1': icon290,
  'information--highway-reference-location--g2': icon291,
  'information--hiking--g1': icon292,
  'information--hospital--g1': icon293,
  'information--hurricane-evacuation-route--g1': icon294,
  'information--interstate-route--g1': icon295,
  'information--lane-control-intersections--g1': icon296,
  'information--lane-control-left-turn--g1': icon297,
  'information--lane-control-multiple-lanes--g1': icon298,
  'information--lane-control-multiple-lanes--g2': icon299,
  'information--lane-control-right-turn--g1': icon300,
  'information--limited-access-road--g1': icon301,
  'information--litter-container--g1': icon302,
  'information--living-street--g1': icon303,
  'information--living-street--g2': icon304,
  'information--living-street--g3': icon305,
  'information--lodging--g1': icon306,
  'information--lodging--g2': icon307,
  'information--minimum-speed-10--g1': icon308,
  'information--minimum-speed-20--g1': icon309,
  'information--minimum-speed-25--g1': icon310,
  'information--minimum-speed-30--g1': icon311,
  'information--minimum-speed-35--g1': icon312,
  'information--minimum-speed-40--g1': icon313,
  'information--minimum-speed-50--g1': icon314,
  'information--minimum-speed-60--g1': icon315,
  'information--minimum-speed-70--g1': icon316,
  'information--minimum-speed-75--g1': icon317,
  'information--minimum-speed-80--g1': icon318,
  'information--minimum-speed-90--g1': icon319,
  'information--minimum-speed-100--g1': icon320,
  'information--minimum-speed-110--g1': icon321,
  'information--minimum-speed-120--g1': icon322,
  'information--minimum-speed-130--g1': icon323,
  'information--motorway--g1': icon324,
  'information--motorway-exit-ahead--g1': icon325,
  'information--motorway-exit-ahead--g2': icon326,
  'information--motorway-exit-ahead--g3': icon327,
  'information--overtaking-allowed-heavy-good-vehicles--g1': icon328,
  'information--parallel-parking--g1': icon329,
  'information--park-and-ride--g1': icon330,
  'information--park-and-ride--g2': icon331,
  'information--parking--g1': icon332,
  'information--parking--g2': icon333,
  'information--parking--g3': icon334,
  'information--parking--g4': icon335,
  'information--parking--g5': icon336,
  'information--parking--g6': icon337,
  'information--parking-area--g1': icon338,
  'information--parking-with-restrictions--g1': icon339,
  'information--pass-on-either-side--g1': icon340,
  'information--passenger-loading-zone--g1': icon341,
  'information--pedestrians-crossing--g1': icon342,
  'information--pedestrians-crossing--g2': icon343,
  'information--pedestrians-crossing--g3': icon344,
  'information--pedestrians-only--g4': icon345,
  'information--pedestrians-permitted--g1': icon346,
  'information--perpendicular-parking--g1': icon347,
  'information--picnic-site--g1': icon348,
  'information--playground--g1': icon349,
  'information--recreational-vehicle-sanitary-station--g1': icon350,
  'information--recycle-collection-center--g1': icon351,
  'information--rest-area--g1': icon352,
  'information--road-bump--g1': icon353,
  'information--road-skating--g1': icon354,
  'information--safety-zone--g1': icon355,
  'information--safety-zone--g2': icon356,
  'information--safety-zone--g3': icon357,
  'information--shared-path-vehicles-and-motorcycles--g1': icon358,
  'information--stairs--g1': icon359,
  'information--stairs--g2': icon360,
  'information--stairs--g3': icon361,
  'information--stairs--g4': icon362,
  'information--stop-line--g1': icon363,
  'information--stop-permitted--g1': icon364,
  'information--street-name-one-line--g1': icon365,
  'information--street-name-three-lines--g1': icon366,
  'information--street-name-two-lines--g1': icon367,
  'information--subway--g1': icon368,
  'information--telephone--g1': icon369,
  'information--telephone--g2': icon370,
  'information--telephone-device-for-the-deaf--g1': icon371,
  'information--toll-station--g1': icon372,
  'information--tourism-information--g1': icon373,
  'information--tourist-attraction--g1': icon374,
  'information--traffic-merges-left--g1': icon375,
  'information--traffic-merges-right--g1': icon376,
  'information--trail-crossing--g1': icon377,
  'information--trail-crossing--g2': icon378,
  'information--trail-crossing--g3': icon379,
  'information--trailer-camping--g1': icon380,
  'information--train-or-light-rail-station--g1': icon381,
  'information--tram-bus-stop--g1': icon382,
  'information--tram-bus-stop--g2': icon383,
  'information--trams-crossing--g1': icon384,
  'information--truck-lane-left--g1': icon385,
  'information--truck-parking--g1': icon386,
  'information--truck-trailer-lane-right--g1': icon387,
  'information--truck-trailer-lane-straight--g1': icon388,
  'information--trucks-both-ways--g1': icon389,
  'information--trucks-only--g1': icon390,
  'information--tsunami-evacuation_route--g1': icon391,
  'information--tunnel--g1': icon392,
  'information--tunnel--g2': icon393,
  'information--tunnel--g3': icon394,
  'information--tunnel-ahead--g1': icon395,
  'information--turn-left--g1': icon396,
  'information--turn-left-ahead--g1': icon397,
  'information--turn-right--g1': icon398,
  'information--turn-right-ahead--g1': icon399,
  'information--urban-area--g1': icon400,
  'information--vehicles-on-rails--g1': icon401,
  'information--water-protection-zone--g1': icon402,
  'information--weight-and-height-limit--g1': icon403,
  'information--weight-limit--g1': icon404,
  'information--wireless-internet--g1': icon405,
  'regulatory--advisory-maximum-speed-limit--g1': icon406,
  'regulatory--all-directions-permitted--g1': icon407,
  'regulatory--all-way--g1': icon408,
  'regulatory--atvs-permitted--g1': icon409,
  'regulatory--axle-limit--g1': icon410,
  'regulatory--axle-limit--g2': icon411,
  'regulatory--bicycle-lane-left--g1': icon412,
  'regulatory--bicycle-parking--g1': icon413,
  'regulatory--bicycles-and-buses-only--g1': icon414,
  'regulatory--bicycles-only--g1': icon415,
  'regulatory--bicycles-only--g2': icon416,
  'regulatory--bicycles-only--g3': icon417,
  'regulatory--bicycles-only--g4': icon418,
  'regulatory--bicycles-push-button--g1': icon419,
  'regulatory--bicycles-push-button--g2': icon420,
  'regulatory--bicycles-stop-on-red--g1': icon421,
  'regulatory--bicycles-wrong-way--g1': icon422,
  'regulatory--bicycles-yield-or-use-signal--g1': icon423,
  'regulatory--bike-route--g1': icon424,
  'regulatory--building-direction--g1': icon425,
  'regulatory--bus-priority-lane--g1': icon426,
  'regulatory--buses-and-taxi-only--g1': icon427,
  'regulatory--buses-only--g1': icon428,
  'regulatory--buses-only--g2': icon429,
  'regulatory--circular-intersection--g1': icon430,
  'regulatory--circular-intersection--g2': icon431,
  'regulatory--circular-intersection--g3': icon432,
  'regulatory--circular-intersection--g4': icon433,
  'regulatory--cross-only-on-green--g1': icon434,
  'regulatory--cross-only-on-pedestrian-signal--g1': icon435,
  'regulatory--crosswalk-stop-on-red--g1': icon436,
  'regulatory--cycling-restriction--g1': icon437,
  'regulatory--cyclists-dismount-and-walk--g1': icon438,
  'regulatory--detour-left--g1': icon439,
  'regulatory--detour-right--g1': icon440,
  'regulatory--divided-highway-crossing--g1': icon441,
  'regulatory--divided-highway-ends--g1': icon442,
  'regulatory--divided-highway-starts--g1': icon443,
  'regulatory--do-not-block-intersection--g1': icon444,
  'regulatory--do-not-pass--g1': icon445,
  'regulatory--do-not-stop-on-tracks--g1': icon446,
  'regulatory--dual-lanes-all-directions-on-left--g1': icon447,
  'regulatory--dual-lanes-all-directions-on-right--g1': icon448,
  'regulatory--dual-lanes-bicyclists-and-pedestrians--g1': icon449,
  'regulatory--dual-lanes-go-left-or-right--g1': icon450,
  'regulatory--dual-lanes-go-straight-on-left--g1': icon451,
  'regulatory--dual-lanes-go-straight-on-right--g1': icon452,
  'regulatory--dual-lanes-turn-left--g1': icon453,
  'regulatory--dual-lanes-turn-left-no-u-turn--g1': icon454,
  'regulatory--dual-lanes-turn-left-or-straight--g1': icon455,
  'regulatory--dual-lanes-turn-right-or-straight--g1': icon456,
  'regulatory--dual-path-bicycles-and-pedestrians--g1': icon457,
  'regulatory--dual-path-bicycles-and-pedestrians--g2': icon458,
  'regulatory--dual-path-bicycles-and-pedestrians--g3': icon459,
  'regulatory--dual-path-equestrians-and-pedestrians--g1': icon460,
  'regulatory--dual-path-equestrians-and-pedestrians-bicycles--g1': icon461,
  'regulatory--dual-path-pedestrians-and-bicycles--g1': icon462,
  'regulatory--dual-path-pedestrians-and-bicycles--g2': icon463,
  'regulatory--dual-path-pedestrians-and-equestrians--g1': icon464,
  'regulatory--dual-path-pedestrians-bicycles-and-equestrians--g1': icon465,
  'regulatory--dual-speed-limits--g1': icon466,
  'regulatory--dual-speed-limits--g2': icon467,
  'regulatory--end-of-bicycles-only--g1': icon468,
  'regulatory--end-of-bicycles-only--g2': icon469,
  'regulatory--end-of-bus-and-taxi-only--g1': icon470,
  'regulatory--end-of-buses-only--g1': icon471,
  'regulatory--end-of-buses-only--g2': icon472,
  'regulatory--end-of-cycling-restriction--g1': icon473,
  'regulatory--end-of-dual-path-bicycles-and-pedestrians--g1': icon474,
  'regulatory--end-of-dual-path-pedestrians-and-bicycles--g1': icon475,
  'regulatory--end-of-equestrians-only--g1': icon476,
  'regulatory--end-of-low-beam-headlights--g1': icon477,
  'regulatory--end-of-maximum-speed-limit-10--g1': icon478,
  'regulatory--end-of-maximum-speed-limit-10--g2': icon479,
  'regulatory--end-of-maximum-speed-limit-20--g1': icon480,
  'regulatory--end-of-maximum-speed-limit-20--g2': icon481,
  'regulatory--end-of-maximum-speed-limit-25--g1': icon482,
  'regulatory--end-of-maximum-speed-limit-25--g2': icon483,
  'regulatory--end-of-maximum-speed-limit-30--g1': icon484,
  'regulatory--end-of-maximum-speed-limit-30--g2': icon485,
  'regulatory--end-of-maximum-speed-limit-35--g1': icon486,
  'regulatory--end-of-maximum-speed-limit-35--g2': icon487,
  'regulatory--end-of-maximum-speed-limit-40--g1': icon488,
  'regulatory--end-of-maximum-speed-limit-40--g2': icon489,
  'regulatory--end-of-maximum-speed-limit-50--g1': icon490,
  'regulatory--end-of-maximum-speed-limit-50--g2': icon491,
  'regulatory--end-of-maximum-speed-limit-60--g1': icon492,
  'regulatory--end-of-maximum-speed-limit-60--g2': icon493,
  'regulatory--end-of-maximum-speed-limit-65--g1': icon494,
  'regulatory--end-of-maximum-speed-limit-65--g2': icon495,
  'regulatory--end-of-maximum-speed-limit-70--g1': icon496,
  'regulatory--end-of-maximum-speed-limit-70--g2': icon497,
  'regulatory--end-of-maximum-speed-limit-75--g1': icon498,
  'regulatory--end-of-maximum-speed-limit-75--g2': icon499,
  'regulatory--end-of-maximum-speed-limit-80--g1': icon500,
  'regulatory--end-of-maximum-speed-limit-80--g2': icon501,
  'regulatory--end-of-maximum-speed-limit-90--g1': icon502,
  'regulatory--end-of-maximum-speed-limit-90--g2': icon503,
  'regulatory--end-of-maximum-speed-limit-100--g1': icon504,
  'regulatory--end-of-maximum-speed-limit-100--g2': icon505,
  'regulatory--end-of-maximum-speed-limit-110--g1': icon506,
  'regulatory--end-of-maximum-speed-limit-110--g2': icon507,
  'regulatory--end-of-maximum-speed-limit-120--g1': icon508,
  'regulatory--end-of-maximum-speed-limit-120--g2': icon509,
  'regulatory--end-of-maximum-speed-limit-130--g1': icon510,
  'regulatory--end-of-maximum-speed-limit-130--g2': icon511,
  'regulatory--end-of-maximum-speed-limit--g1': icon512,
  'regulatory--end-of-mopeds-and-bicycles-only--g1': icon513,
  'regulatory--end-of-no-heavy-goods-vehicles--g1': icon514,
  'regulatory--end-of-no-horn--g1': icon515,
  'regulatory--end-of-no-overtaking--g1': icon516,
  'regulatory--end-of-no-overtaking--g2': icon517,
  'regulatory--end-of-no-overtaking--g3': icon518,
  'regulatory--end-of-no-overtaking--g4': icon519,
  'regulatory--end-of-no-overtaking--g5': icon520,
  'regulatory--end-of-no-overtaking-by-heavy-goods-vehicles--g1': icon521,
  'regulatory--end-of-no-overtaking-by-heavy-goods-vehicles--g2': icon522,
  'regulatory--end-of-no-overtaking-by-motorcycles--g1': icon523,
  'regulatory--end-of-no-parking--g1': icon524,
  'regulatory--end-of-no-parking--g2': icon525,
  'regulatory--end-of-no-parking-or-stopping--g1': icon526,
  'regulatory--end-of-one-way-straight--g1': icon527,
  'regulatory--end-of-parking-zone--g1': icon528,
  'regulatory--end-of-parking-zone--g2': icon529,
  'regulatory--end-of-pedestrians-only--g1': icon530,
  'regulatory--end-of-pedestrians-only--g2': icon531,
  'regulatory--end-of-pedestrians-only--g3': icon532,
  'regulatory--end-of-pedestrians-only--g4': icon533,
  'regulatory--end-of-priority-road--g1': icon534,
  'regulatory--end-of-prohibition--g1': icon535,
  'regulatory--end-of-school-zone--g1': icon536,
  'regulatory--end-of-shared-path-bicycles-and-pedestrians--g1': icon537,
  'regulatory--end-of-shared-path-pedestrians-and-bicycles--g1': icon538,
  'regulatory--end-of-snow-chains--g1': icon539,
  'regulatory--end-of-snow-chains--g2': icon540,
  'regulatory--end-of-snowmobiles-only--g1': icon541,
  'regulatory--end-of-speed-limit-zone--g1': icon542,
  'regulatory--end-of-speed-limit-zone--g2': icon543,
  'regulatory--end-of-speed-limit-zone--g3': icon544,
  'regulatory--end-of-tractors-only--g1': icon545,
  'regulatory--end-of-trams-and-buses-only--g1': icon546,
  'regulatory--end-of-trams-only--g1': icon547,
  'regulatory--end-of-trucks-and-buses-only--g1': icon548,
  'regulatory--end-of-trucks-only--g1': icon549,
  'regulatory--end-of-trucks-only--g2': icon550,
  'regulatory--equestrians-only--g1': icon551,
  'regulatory--except-railroad-crossing--g1': icon552,
  'regulatory--fine-for-littering--g1': icon553,
  'regulatory--give-way-to-bicycles--g1': icon554,
  'regulatory--give-way-to-oncoming-traffic--g1': icon555,
  'regulatory--give-way-to-oncoming-traffic--g2': icon556,
  'regulatory--go-left-bicycles--g1': icon557,
  'regulatory--go-right-bicycles--g1': icon558,
  'regulatory--go-straight--g1': icon559,
  'regulatory--go-straight--g3': icon560,
  'regulatory--go-straight-bicycles--g1': icon561,
  'regulatory--go-straight-or-turn-left--g1': icon562,
  'regulatory--go-straight-or-turn-left--g2': icon563,
  'regulatory--go-straight-or-turn-left--g3': icon564,
  'regulatory--go-straight-or-turn-right--g1': icon565,
  'regulatory--go-straight-or-turn-right--g2': icon566,
  'regulatory--go-straight-or-turn-right--g3': icon567,
  'regulatory--heavy-goods-vehicles-permitted--g1': icon568,
  'regulatory--height-limit--g1': icon569,
  'regulatory--high-beam-headlights--g1': icon570,
  'regulatory--horn--g1': icon571,
  'regulatory--in-street-pedestrian-crossing--g1': icon572,
  'regulatory--keep-left--g1': icon573,
  'regulatory--keep-left--g2': icon574,
  'regulatory--keep-left--g3': icon575,
  'regulatory--keep-left--g4': icon576,
  'regulatory--keep-left--g5': icon577,
  'regulatory--keep-left--g6': icon578,
  'regulatory--keep-left--g7': icon579,
  'regulatory--keep-right--g1': icon580,
  'regulatory--keep-right--g2': icon581,
  'regulatory--keep-right--g3': icon582,
  'regulatory--keep-right--g4': icon583,
  'regulatory--keep-right--g5': icon584,
  'regulatory--keep-right--g6': icon585,
  'regulatory--keep-right--g7': icon586,
  'regulatory--keep-right--g8': icon587,
  'regulatory--keep-right--g9': icon588,
  'regulatory--lane-control--g1': icon589,
  'regulatory--left-turn-yield-on-green--g1': icon590,
  'regulatory--length-limit--g1': icon591,
  'regulatory--length-limit--g2': icon592,
  'regulatory--light-rail-divided-highway--g1': icon593,
  'regulatory--light-rail-do-not-pass--g1': icon594,
  'regulatory--light-rail-only--g1': icon595,
  'regulatory--look--g1': icon596,
  'regulatory--low-beam-headlights--g1': icon597,
  'regulatory--low-beam-headlights--g2': icon598,
  'regulatory--low-beam-headlights--g3': icon599,
  'regulatory--low-speed-vehicle-permitted--g1': icon600,
  'regulatory--maximum-speed-limit-5--g1': icon601,
  'regulatory--maximum-speed-limit-5--g3': icon602,
  'regulatory--maximum-speed-limit-10--g1': icon603,
  'regulatory--maximum-speed-limit-10--g3': icon604,
  'regulatory--maximum-speed-limit-15--g1': icon605,
  'regulatory--maximum-speed-limit-15--g3': icon606,
  'regulatory--maximum-speed-limit-20--g1': icon607,
  'regulatory--maximum-speed-limit-20--g3': icon608,
  'regulatory--maximum-speed-limit-25--g1': icon609,
  'regulatory--maximum-speed-limit-25--g2': icon610,
  'regulatory--maximum-speed-limit-30--g1': icon611,
  'regulatory--maximum-speed-limit-30--g3': icon612,
  'regulatory--maximum-speed-limit-35--g1': icon613,
  'regulatory--maximum-speed-limit-35--g2': icon614,
  'regulatory--maximum-speed-limit-40--g1': icon615,
  'regulatory--maximum-speed-limit-40--g3': icon616,
  'regulatory--maximum-speed-limit-45--g1': icon617,
  'regulatory--maximum-speed-limit-45--g3': icon618,
  'regulatory--maximum-speed-limit-50--g1': icon619,
  'regulatory--maximum-speed-limit-50--g3': icon620,
  'regulatory--maximum-speed-limit-55--g2': icon621,
  'regulatory--maximum-speed-limit-60--g1': icon622,
  'regulatory--maximum-speed-limit-60--g3': icon623,
  'regulatory--maximum-speed-limit-65--g1': icon624,
  'regulatory--maximum-speed-limit-65--g2': icon625,
  'regulatory--maximum-speed-limit-70--g1': icon626,
  'regulatory--maximum-speed-limit-70--g3': icon627,
  'regulatory--maximum-speed-limit-75--g2': icon628,
  'regulatory--maximum-speed-limit-80--g1': icon629,
  'regulatory--maximum-speed-limit-80--g3': icon630,
  'regulatory--maximum-speed-limit-85--g2': icon631,
  'regulatory--maximum-speed-limit-90--g1': icon632,
  'regulatory--maximum-speed-limit-90--g3': icon633,
  'regulatory--maximum-speed-limit-100--g1': icon634,
  'regulatory--maximum-speed-limit-100--g3': icon635,
  'regulatory--maximum-speed-limit-110--g1': icon636,
  'regulatory--maximum-speed-limit-110--g3': icon637,
  'regulatory--maximum-speed-limit-120--g1': icon638,
  'regulatory--maximum-speed-limit-120--g3': icon639,
  'regulatory--maximum-speed-limit-130--g1': icon640,
  'regulatory--maximum-speed-limit-130--g3': icon641,
  'regulatory--maximum-speed-limit-led-5--g2': icon642,
  'regulatory--maximum-speed-limit-led-5--g3': icon643,
  'regulatory--maximum-speed-limit-led-10--g1': icon644,
  'regulatory--maximum-speed-limit-led-10--g2': icon645,
  'regulatory--maximum-speed-limit-led-10--g3': icon646,
  'regulatory--maximum-speed-limit-led-15--g2': icon647,
  'regulatory--maximum-speed-limit-led-15--g3': icon648,
  'regulatory--maximum-speed-limit-led-20--g1': icon649,
  'regulatory--maximum-speed-limit-led-20--g2': icon650,
  'regulatory--maximum-speed-limit-led-20--g3': icon651,
  'regulatory--maximum-speed-limit-led-25--g1': icon652,
  'regulatory--maximum-speed-limit-led-25--g2': icon653,
  'regulatory--maximum-speed-limit-led-25--g3': icon654,
  'regulatory--maximum-speed-limit-led-30--g1': icon655,
  'regulatory--maximum-speed-limit-led-30--g2': icon656,
  'regulatory--maximum-speed-limit-led-30--g3': icon657,
  'regulatory--maximum-speed-limit-led-35--g1': icon658,
  'regulatory--maximum-speed-limit-led-35--g2': icon659,
  'regulatory--maximum-speed-limit-led-35--g3': icon660,
  'regulatory--maximum-speed-limit-led-40--g1': icon661,
  'regulatory--maximum-speed-limit-led-40--g2': icon662,
  'regulatory--maximum-speed-limit-led-40--g3': icon663,
  'regulatory--maximum-speed-limit-led-45--g2': icon664,
  'regulatory--maximum-speed-limit-led-45--g3': icon665,
  'regulatory--maximum-speed-limit-led-50--g1': icon666,
  'regulatory--maximum-speed-limit-led-50--g2': icon667,
  'regulatory--maximum-speed-limit-led-50--g3': icon668,
  'regulatory--maximum-speed-limit-led-55--g2': icon669,
  'regulatory--maximum-speed-limit-led-55--g3': icon670,
  'regulatory--maximum-speed-limit-led-60--g1': icon671,
  'regulatory--maximum-speed-limit-led-60--g2': icon672,
  'regulatory--maximum-speed-limit-led-60--g3': icon673,
  'regulatory--maximum-speed-limit-led-65--g2': icon674,
  'regulatory--maximum-speed-limit-led-65--g3': icon675,
  'regulatory--maximum-speed-limit-led-70--g1': icon676,
  'regulatory--maximum-speed-limit-led-70--g2': icon677,
  'regulatory--maximum-speed-limit-led-70--g3': icon678,
  'regulatory--maximum-speed-limit-led-75--g1': icon679,
  'regulatory--maximum-speed-limit-led-75--g2': icon680,
  'regulatory--maximum-speed-limit-led-75--g3': icon681,
  'regulatory--maximum-speed-limit-led-80--g1': icon682,
  'regulatory--maximum-speed-limit-led-80--g2': icon683,
  'regulatory--maximum-speed-limit-led-80--g3': icon684,
  'regulatory--maximum-speed-limit-led-85--g2': icon685,
  'regulatory--maximum-speed-limit-led-85--g3': icon686,
  'regulatory--maximum-speed-limit-led-90--g1': icon687,
  'regulatory--maximum-speed-limit-led-100--g1': icon688,
  'regulatory--maximum-speed-limit-led-110--g1': icon689,
  'regulatory--maximum-speed-limit-led-120--g1': icon690,
  'regulatory--maximum-speed-limit-led-130--g1': icon691,
  'regulatory--minimum-safe-distance--g1': icon692,
  'regulatory--minimum-safe-distance--g2': icon693,
  'regulatory--mopeds-and-bicycles-only--g1': icon694,
  'regulatory--motorcycles-and-bicycles-only--g1': icon695,
  'regulatory--motorcycles-only--g1': icon696,
  'regulatory--motorcycles-only--g2': icon697,
  'regulatory--night-speed-limit-5--g1': icon698,
  'regulatory--night-speed-limit-10--g1': icon699,
  'regulatory--night-speed-limit-15--g1': icon700,
  'regulatory--night-speed-limit-20--g1': icon701,
  'regulatory--night-speed-limit-25--g1': icon702,
  'regulatory--night-speed-limit-30--g1': icon703,
  'regulatory--night-speed-limit-35--g1': icon704,
  'regulatory--night-speed-limit-40--g1': icon705,
  'regulatory--night-speed-limit-45--g1': icon706,
  'regulatory--night-speed-limit-50--g1': icon707,
  'regulatory--night-speed-limit-55--g1': icon708,
  'regulatory--night-speed-limit-60--g1': icon709,
  'regulatory--night-speed-limit-65--g1': icon710,
  'regulatory--night-speed-limit-70--g1': icon711,
  'regulatory--night-speed-limit-75--g1': icon712,
  'regulatory--night-speed-limit-80--g1': icon713,
  'regulatory--night-speed-limit-85--g1': icon714,
  'regulatory--no-abnormal-vehicles--g1': icon715,
  'regulatory--no-atvs--g1': icon716,
  'regulatory--no-bicycles--g1': icon717,
  'regulatory--no-bicycles--g2': icon718,
  'regulatory--no-bicycles--g3': icon719,
  'regulatory--no-bicycles-carts-or-hand-carts--g1': icon720,
  'regulatory--no-bicycles-mopeds-or-motorcycles--g1': icon721,
  'regulatory--no-bicycles-mopeds-or-motorcycles--g2': icon722,
  'regulatory--no-bicycles-or-hand-carts--g1': icon723,
  'regulatory--no-bicycles-or-motorcycles--g1': icon724,
  'regulatory--no-bicycles-tractors-or-carts--g1': icon725,
  'regulatory--no-buses--g1': icon726,
  'regulatory--no-buses--g2': icon727,
  'regulatory--no-buses--g3': icon728,
  'regulatory--no-caravan-trailers--g1': icon729,
  'regulatory--no-caravans--g1': icon730,
  'regulatory--no-caravans-or-caravan-trailers--g1': icon731,
  'regulatory--no-cargo-loading--g1': icon732,
  'regulatory--no-carts--g1': icon733,
  'regulatory--no-carts--g2': icon734,
  'regulatory--no-carts--g3': icon735,
  'regulatory--no-carts-or-tractors--g1': icon736,
  'regulatory--no-construction-vehicles--g1': icon737,
  'regulatory--no-entry--g1': icon738,
  'regulatory--no-equestrians--g1': icon739,
  'regulatory--no-go-straight-or-turn-left--g1': icon740,
  'regulatory--no-go-straight-or-turn-right--g1': icon741,
  'regulatory--no-good-trailers--g2': icon742,
  'regulatory--no-goods-vehicle-trailers--g1': icon743,
  'regulatory--no-hand-carts--g1': icon744,
  'regulatory--no-hand-carts--g2': icon745,
  'regulatory--no-hand-carts-or-bicycles--g1': icon746,
  'regulatory--no-hawkers--g1': icon747,
  'regulatory--no-heavy-goods-vehicles--g1': icon748,
  'regulatory--no-heavy-goods-vehicles--g2': icon749,
  'regulatory--no-heavy-goods-vehicles--g3': icon750,
  'regulatory--no-heavy-goods-vehicles--g4': icon751,
  'regulatory--no-heavy-goods-vehicles--g5': icon752,
  'regulatory--no-heavy-goods-vehicles-motorcycles-or-bicycles--g1': icon753,
  'regulatory--no-heavy-goods-vehicles-motorcycles-or-bicycles--g2': icon754,
  'regulatory--no-heavy-goods-vehicles-or-buses--g1': icon755,
  'regulatory--no-heavy-goods-vehicles-or-tractors--g1': icon756,
  'regulatory--no-heavy-goods-vehicles-or-trailers--g1': icon757,
  'regulatory--no-horizontal-turn--g1': icon758,
  'regulatory--no-horn--g1': icon759,
  'regulatory--no-horn--g2': icon760,
  'regulatory--no-lane-change-to-left--g1': icon761,
  'regulatory--no-lane-change-to-right--g1': icon762,
  'regulatory--no-learner-drivers--g1': icon763,
  'regulatory--no-left-or-u-turn--g1': icon764,
  'regulatory--no-left-turn--g1': icon765,
  'regulatory--no-left-turn--g2': icon766,
  'regulatory--no-left-turn--g3': icon767,
  'regulatory--no-left-turn--g4': icon768,
  'regulatory--no-left-turn--g5': icon769,
  'regulatory--no-low-speed-vehicles--g1': icon770,
  'regulatory--no-mopeds-or-bicycles--g1': icon771,
  'regulatory--no-motor-vehicle-trailers--g1': icon772,
  'regulatory--no-motor-vehicles--g1': icon773,
  'regulatory--no-motor-vehicles--g3': icon774,
  'regulatory--no-motor-vehicles--g4': icon775,
  'regulatory--no-motor-vehicles--g5': icon776,
  'regulatory--no-motor-vehicles--g6': icon777,
  'regulatory--no-motor-vehicles--g7': icon778,
  'regulatory--no-motor-vehicles-except-motorcycles--g1': icon779,
  'regulatory--no-motor-vehicles-except-motorcycles--g2': icon780,
  'regulatory--no-motor-vehicles-except-motorcycles--g3': icon781,
  'regulatory--no-motor-vehicles-or-bicycles--g1': icon782,
  'regulatory--no-motor-vehicles-or-buses--g1': icon783,
  'regulatory--no-motor-vehicles-or-carts--g1': icon784,
  'regulatory--no-motorcycles--g1': icon785,
  'regulatory--no-motorcycles--g2': icon786,
  'regulatory--no-overtaking--g1': icon787,
  'regulatory--no-overtaking--g2': icon788,
  'regulatory--no-overtaking--g4': icon789,
  'regulatory--no-overtaking--g5': icon790,
  'regulatory--no-overtaking--g6': icon791,
  'regulatory--no-overtaking--g7': icon792,
  'regulatory--no-overtaking-atvs--g1': icon793,
  'regulatory--no-overtaking-by-heavy-goods-vehicles--g1': icon794,
  'regulatory--no-parking--g1': icon795,
  'regulatory--no-parking--g2': icon796,
  'regulatory--no-parking--g3': icon797,
  'regulatory--no-parking--g4': icon798,
  'regulatory--no-parking--g5': icon799,
  'regulatory--no-parking--g6': icon800,
  'regulatory--no-parking--g7': icon801,
  'regulatory--no-parking--g8': icon802,
  'regulatory--no-parking--g9': icon803,
  'regulatory--no-parking-bicycles-or-motorcycles--g1': icon804,
  'regulatory--no-parking-bus-stop--g1': icon805,
  'regulatory--no-parking-or-no-stopping--g1': icon806,
  'regulatory--no-parking-or-no-stopping--g2': icon807,
  'regulatory--no-parking-or-no-stopping--g3': icon808,
  'regulatory--no-parking-or-no-stopping--g4': icon809,
  'regulatory--no-parking-or-no-stopping--g5': icon810,
  'regulatory--no-passenger-loading--g1': icon811,
  'regulatory--no-pedestrians--g1': icon812,
  'regulatory--no-pedestrians--g2': icon813,
  'regulatory--no-pedestrians--g3': icon814,
  'regulatory--no-pedestrians--g4': icon815,
  'regulatory--no-pedestrians--g5': icon816,
  'regulatory--no-pedestrians--g6': icon817,
  'regulatory--no-pedestrians-bicycles-animals-or-hand-carts--g1': icon818,
  'regulatory--no-pedestrians-or-bicycles--g1': icon819,
  'regulatory--no-pedestrians-or-bicycles--g2': icon820,
  'regulatory--no-pedestrians-or-bicycles--g3': icon821,
  'regulatory--no-rickshaws--g1': icon822,
  'regulatory--no-rickshaws--g2': icon823,
  'regulatory--no-rickshaws--g3': icon824,
  'regulatory--no-right-turn--g1': icon825,
  'regulatory--no-right-turn--g2': icon826,
  'regulatory--no-right-turn--g3': icon827,
  'regulatory--no-right-turn-on-red--g1': icon828,
  'regulatory--no-skiing--g1': icon829,
  'regulatory--no-snowmobiles--g1': icon830,
  'regulatory--no-snowmobiles--g2': icon831,
  'regulatory--no-snowmobiles-or-atvs--g1': icon832,
  'regulatory--no-stopping--g1': icon833,
  'regulatory--no-stopping--g2': icon834,
  'regulatory--no-stopping--g3': icon835,
  'regulatory--no-stopping--g5': icon836,
  'regulatory--no-stopping--g6': icon837,
  'regulatory--no-stopping--g7': icon838,
  'regulatory--no-stopping-on-pavement--g1': icon839,
  'regulatory--no-straight-through--g1': icon840,
  'regulatory--no-straight-through--g2': icon841,
  'regulatory--no-studded-snow-chains--g1': icon842,
  'regulatory--no-through-trucks--g1': icon843,
  'regulatory--no-tour-buses--g1': icon844,
  'regulatory--no-tractors--g1': icon845,
  'regulatory--no-tractors-mopeds-or-bicycles--g1': icon846,
  'regulatory--no-tractors-or-carts--g1': icon847,
  'regulatory--no-trailers--g1': icon848,
  'regulatory--no-tricycles--g1': icon849,
  'regulatory--no-tricycles-or-hand-carts--g1': icon850,
  'regulatory--no-turn-on-red--g1': icon851,
  'regulatory--no-turn-on-red--g2': icon852,
  'regulatory--no-turn-on-red--g3': icon853,
  'regulatory--no-turns--g1': icon854,
  'regulatory--no-turns--g2': icon855,
  'regulatory--no-two-stage-right-turn-for-mopeds--g1': icon856,
  'regulatory--no-u-turn--g1': icon857,
  'regulatory--no-u-turn--g2': icon858,
  'regulatory--no-u-turn--g3': icon859,
  'regulatory--no-vehicles-carrying-dangerous-goods--g1': icon860,
  'regulatory--no-vehicles-carrying-dangerous-goods--g2': icon861,
  'regulatory--no-vehicles-carrying-dangerous-goods--g3': icon862,
  'regulatory--no-vehicles-carrying-dangerous-goods--g4': icon863,
  'regulatory--no-vehicles-carrying-dangerous-water-pollutants--g1': icon864,
  'regulatory--no-vehicles-carrying-dangerous-water-pollutants--g2': icon865,
  'regulatory--no-vehicles-carrying-explosives--g1': icon866,
  'regulatory--no-vehicles-carrying-explosives-or-dangerous-water-pollutants--g1': icon867,
  'regulatory--one-way-left--g1': icon868,
  'regulatory--one-way-left--g2': icon869,
  'regulatory--one-way-left--g3': icon870,
  'regulatory--one-way-right--g1': icon871,
  'regulatory--one-way-right--g2': icon872,
  'regulatory--one-way-right--g3': icon873,
  'regulatory--one-way-straight--g1': icon874,
  'regulatory--one-way-straight--g3': icon875,
  'regulatory--parking-fee-station--g1': icon876,
  'regulatory--parking-restrictions--g1': icon877,
  'regulatory--parking-restrictions--g2': icon878,
  'regulatory--parking-restrictions--g3': icon879,
  'regulatory--pass-on-either-side--g1': icon880,
  'regulatory--pass-on-either-side--g2': icon881,
  'regulatory--pass-on-either-side--g3': icon882,
  'regulatory--pass-with-care--g1': icon883,
  'regulatory--passing-lane-ahead--g1': icon884,
  'regulatory--pedestrians-bicycles-permitted--g1': icon885,
  'regulatory--pedestrians-keep-left--g1': icon886,
  'regulatory--pedestrians-only--g1': icon887,
  'regulatory--pedestrians-only--g2': icon888,
  'regulatory--pedestrians-only--g3': icon889,
  'regulatory--pedestrians-priority-zone--g1': icon890,
  'regulatory--pedestrians-push-button--g1': icon891,
  'regulatory--pedestrians-push-button--g2': icon892,
  'regulatory--priority-over-oncoming-vehicles--g1': icon893,
  'regulatory--priority-over-oncoming-vehicles--g2': icon894,
  'regulatory--priority-road--g1': icon895,
  'regulatory--priority-road--g2': icon896,
  'regulatory--radar-enforced--g1': icon897,
  'regulatory--reserved-parking--g1': icon898,
  'regulatory--reversible-lanes--g1': icon899,
  'regulatory--reversible-lanes--g2': icon900,
  'regulatory--road-closed--g1': icon901,
  'regulatory--road-closed--g2': icon902,
  'regulatory--road-closed-to-vehicles--g1': icon903,
  'regulatory--road-closed-to-vehicles--g3': icon904,
  'regulatory--roundabout--g1': icon905,
  'regulatory--roundabout--g2': icon906,
  'regulatory--roundabout--g3': icon907,
  'regulatory--shared-path-bicycles-and-pedestrians--g1': icon908,
  'regulatory--shared-path-pedestrians-and-bicycles--g1': icon909,
  'regulatory--sidewalk-closed--g1': icon910,
  'regulatory--slanted-parking--g1': icon911,
  'regulatory--snow-chains--g1': icon912,
  'regulatory--snow-chains--g2': icon913,
  'regulatory--snow-chains--g3': icon914,
  'regulatory--snowmobiles-only--g1': icon915,
  'regulatory--snowmobiles-permitted--g1': icon916,
  'regulatory--speed-limit-zone--g1': icon917,
  'regulatory--speeding-fines-increased--g1': icon918,
  'regulatory--state-route--g1': icon919,
  'regulatory--stay-in-lane--g1': icon920,
  'regulatory--stop--g1': icon921,
  'regulatory--stop--g2': icon922,
  'regulatory--stop--g3': icon923,
  'regulatory--stop--g4': icon924,
  'regulatory--stop--g5': icon925,
  'regulatory--stop--g6': icon926,
  'regulatory--stop--g7': icon927,
  'regulatory--stop--g8': icon928,
  'regulatory--stop--g9': icon929,
  'regulatory--stop--g10': icon930,
  'regulatory--stop-here-on-red-or-flashing-light--g1': icon931,
  'regulatory--stop-here-on-red-or-flashing-light--g2': icon932,
  'regulatory--stop-signals--g1': icon933,
  'regulatory--stop-signals--g2': icon934,
  'regulatory--tanks-only--g1': icon935,
  'regulatory--taxi-only--g1': icon936,
  'regulatory--text--g1': icon937,
  'regulatory--text--g2': icon938,
  'regulatory--toll-pass-only--g1': icon939,
  'regulatory--tractors-only--g1': icon940,
  'regulatory--traffic-signal-photo-enforced--g1': icon941,
  'regulatory--trams-and-buses-only--g1': icon942,
  'regulatory--trams-only--g1': icon943,
  'regulatory--triple-lanes--g1': icon944,
  'regulatory--triple-lanes-go-straight-center-lane--g1': icon945,
  'regulatory--triple-lanes-turn-left-center-lane--g1': icon946,
  'regulatory--triple-lanes-turn-right-center-lane--g1': icon947,
  'regulatory--truck-route--g1': icon948,
  'regulatory--truck-speed-limit-5--g1': icon949,
  'regulatory--truck-speed-limit-10--g1': icon950,
  'regulatory--truck-speed-limit-15--g1': icon951,
  'regulatory--truck-speed-limit-20--g1': icon952,
  'regulatory--truck-speed-limit-25--g1': icon953,
  'regulatory--truck-speed-limit-30--g1': icon954,
  'regulatory--truck-speed-limit-35--g1': icon955,
  'regulatory--truck-speed-limit-40--g1': icon956,
  'regulatory--truck-speed-limit-45--g1': icon957,
  'regulatory--truck-speed-limit-50--g1': icon958,
  'regulatory--truck-speed-limit-55--g1': icon959,
  'regulatory--truck-speed-limit-60--g1': icon960,
  'regulatory--truck-speed-limit-65--g1': icon961,
  'regulatory--truck-speed-limit-70--g1': icon962,
  'regulatory--truck-speed-limit-75--g1': icon963,
  'regulatory--truck-speed-limit-80--g1': icon964,
  'regulatory--truck-speed-limit-85--g1': icon965,
  'regulatory--trucks-and-buses-only--g1': icon966,
  'regulatory--trucks-on-right--g1': icon967,
  'regulatory--trucks-only--g1': icon968,
  'regulatory--turn-left--g1': icon969,
  'regulatory--turn-left--g2': icon970,
  'regulatory--turn-left--g3': icon971,
  'regulatory--turn-left-ahead--g1': icon972,
  'regulatory--turn-left-ahead--g2': icon973,
  'regulatory--turn-left-or-right--g1': icon974,
  'regulatory--turn-left-or-right--g2': icon975,
  'regulatory--turn-left-or-right--g3': icon976,
  'regulatory--turn-left-or-u-turn--g1': icon977,
  'regulatory--turn-right--g1': icon978,
  'regulatory--turn-right--g2': icon979,
  'regulatory--turn-right--g3': icon980,
  'regulatory--turn-right-ahead--g1': icon981,
  'regulatory--turn-right-ahead--g2': icon982,
  'regulatory--turning-vehicles-yield-to-pedestrians--g1': icon983,
  'regulatory--two-stage-right-turn-for-mopeds--g1': icon984,
  'regulatory--two-way--g1': icon985,
  'regulatory--u-turn--g1': icon986,
  'regulatory--u-turn--g2': icon987,
  'regulatory--u-turn--g3': icon988,
  'regulatory--use-crosswalk--g1': icon989,
  'regulatory--vehicles-carrying-dangerous-goods-only--g1': icon990,
  'regulatory--vehicles-carrying-dangerous-goods-permitted--g1': icon991,
  'regulatory--vehicles-carrying-explosives-only--g1': icon992,
  'regulatory--vehicles-carrying-hazardous-goods-permitted--g1': icon993,
  'regulatory--vehicles-only--g1': icon994,
  'regulatory--wear-seat-belt--g1': icon995,
  'regulatory--wear-seat-belt--g2': icon996,
  'regulatory--wear-seat-belt--g3': icon997,
  'regulatory--weight-limit--g1': icon998,
  'regulatory--weight-limit--g2': icon999,
  'regulatory--weight-limit--g3': icon1000,
  'regulatory--weight-limit--g4': icon1001,
  'regulatory--weight-limit--g5': icon1002,
  'regulatory--weight-limit--g6': icon1003,
  'regulatory--weight-limit--g7': icon1004,
  'regulatory--weight-limit-per-axle--g1': icon1005,
  'regulatory--weight-limit-per-tandem-axle--g1': icon1006,
  'regulatory--weight-limit-with-trucks--g1': icon1007,
  'regulatory--width-limit--g1': icon1008,
  'regulatory--wrong-way--g1': icon1009,
  'regulatory--yield--g1': icon1010,
  'regulatory--yield-or-stop-for-pedestrians--g1': icon1011,
  'regulatory--your-speed--g1': icon1012,
  'warning--accident-area--g1': icon1013,
  'warning--accident-area--g2': icon1014,
  'warning--accident-area--g3': icon1015,
  'warning--accident-area--g4': icon1016,
  'warning--accident-area--g5': icon1017,
  'warning--accident-area--g6': icon1018,
  'warning--accident-area--g7': icon1019,
  'warning--accident-area--g8': icon1020,
  'warning--added-lane-from-entering-roadway--g1': icon1021,
  'warning--added-lane-from-entering-roadway--g2': icon1022,
  'warning--added-lane-left--g1': icon1023,
  'warning--added-lane-right--g1': icon1024,
  'warning--animal-drawn-vehicles--g1': icon1025,
  'warning--arch-bridge--g1': icon1026,
  'warning--atv-and-snowmobiles--g1': icon1027,
  'warning--atv-crossing--g1': icon1028,
  'warning--atv-crossing--g2': icon1029,
  'warning--axle-restriction--g1': icon1030,
  'warning--bear-crossing--g1': icon1031,
  'warning--bear-crossing--g2': icon1032,
  'warning--bicycles-and-others--g1': icon1033,
  'warning--bicycles-caution-on-rail-tracks--g1': icon1034,
  'warning--bicycles-crossing--g1': icon1035,
  'warning--bicycles-crossing--g2': icon1036,
  'warning--bicycles-crossing--g3': icon1037,
  'warning--bicycles-crossing--g4': icon1038,
  'warning--bollard--g1': icon1039,
  'warning--bridge--g1': icon1040,
  'warning--bridge--g2': icon1041,
  'warning--bus-stop-ahead--g1': icon1042,
  'warning--bus-stop-ahead--g2': icon1043,
  'warning--bus-stop-ahead--g3': icon1044,
  'warning--camel-crossing--g1': icon1045,
  'warning--camel-crossing--g2': icon1046,
  'warning--camera--g1': icon1047,
  'warning--camera--g2': icon1048,
  'warning--carts--g1': icon1049,
  'warning--carts--g2': icon1050,
  'warning--checkpoint--g1': icon1051,
  'warning--children--g1': icon1052,
  'warning--children--g2': icon1053,
  'warning--children--g3': icon1054,
  'warning--children--g4': icon1055,
  'warning--children--g6': icon1056,
  'warning--cliff--g1': icon1057,
  'warning--cliff--g2': icon1058,
  'warning--closed-lane-in-triple-lanes--g1': icon1059,
  'warning--closed-lane-in-triple-lanes--g2': icon1060,
  'warning--construction-ahead--g1': icon1061,
  'warning--crossroads--g1': icon1062,
  'warning--crossroads--g2': icon1063,
  'warning--crossroads--g3': icon1064,
  'warning--crossroads--g4': icon1065,
  'warning--crossroads--g5': icon1066,
  'warning--crossroads--g6': icon1067,
  'warning--crossroads-with-priority-to-the-right--g1': icon1068,
  'warning--curve-left--g1': icon1069,
  'warning--curve-left--g2': icon1070,
  'warning--curve-left--g3': icon1071,
  'warning--curve-left-with-junction--g1': icon1072,
  'warning--curve-out-intersection-left--g1': icon1073,
  'warning--curve-out-intersection-right--g1': icon1074,
  'warning--curve-right--g1': icon1075,
  'warning--curve-right--g2': icon1076,
  'warning--curve-right--g3': icon1077,
  'warning--curve-right-with-junction--g1': icon1078,
  'warning--dangerous-crosswinds-left--g1': icon1079,
  'warning--dangerous-crosswinds-left--g2': icon1080,
  'warning--dangerous-crosswinds-left--g4': icon1081,
  'warning--dangerous-crosswinds-right--g1': icon1082,
  'warning--dangerous-crosswinds-right--g2': icon1083,
  'warning--dangerous-crosswinds-right--g3': icon1084,
  'warning--dangerous-crosswinds-right--g4': icon1085,
  'warning--dead-end--g1': icon1086,
  'warning--dead-end--g2': icon1087,
  'warning--dead-end--g3': icon1088,
  'warning--dead-end-go-left--g1': icon1089,
  'warning--dead-end-go-right--g1': icon1090,
  'warning--descent-or-climbing-lanes-in-triple-lanes--g1': icon1091,
  'warning--detour-ahead--g1': icon1092,
  'warning--detour-or-construction-ahead--g1': icon1093,
  'warning--dip--g1': icon1094,
  'warning--dip--g2': icon1095,
  'warning--disabled-persons-crossing--g1': icon1096,
  'warning--disabled-persons-crossing--g2': icon1097,
  'warning--divided-highway--g1': icon1098,
  'warning--divided-highway--g2': icon1099,
  'warning--divided-highway--g3': icon1100,
  'warning--divided-highway--g4': icon1101,
  'warning--divided-highway--g5': icon1102,
  'warning--divided-highway--g6': icon1103,
  'warning--divided-highway--g7': icon1104,
  'warning--divided-highway--g8': icon1105,
  'warning--divided-highway--g9': icon1106,
  'warning--divided-highway-ends--g1': icon1107,
  'warning--divided-highway-ends--g2': icon1108,
  'warning--divided-highway-ends--g3': icon1109,
  'warning--divided-highway-ends--g4': icon1110,
  'warning--divided-highway-on-left--g1': icon1111,
  'warning--divided-highway-on-left--g2': icon1112,
  'warning--divided-highway-on-right--g1': icon1113,
  'warning--divided-highway-on-right--g2': icon1114,
  'warning--divided-highway-to-left--g1': icon1115,
  'warning--divided-highway-to-right--g1': icon1116,
  'warning--domestic-animals--g1': icon1117,
  'warning--domestic-animals--g2': icon1118,
  'warning--domestic-animals--g3': icon1119,
  'warning--domestic-animals--g4': icon1120,
  'warning--domestic-animals--g5': icon1121,
  'warning--domestic-animals--g6': icon1122,
  'warning--domestic-animals--g7': icon1123,
  'warning--domestic-animals--g8': icon1124,
  'warning--double-curve-first-left--g1': icon1125,
  'warning--double-curve-first-left--g2': icon1126,
  'warning--double-curve-first-right--g1': icon1127,
  'warning--double-curve-first-right--g2': icon1128,
  'warning--double-descent--g1': icon1129,
  'warning--double-reverse-curve-left--g1': icon1130,
  'warning--double-reverse-curve-left--g2': icon1131,
  'warning--double-reverse-curve-right--g1': icon1132,
  'warning--double-reverse-curve-right--g2': icon1133,
  'warning--double-side-roads-left--g1': icon1134,
  'warning--double-side-roads-left--g3': icon1135,
  'warning--double-side-roads-right--g1': icon1136,
  'warning--double-side-roads-right--g3': icon1137,
  'warning--double-turn-first-left--g1': icon1138,
  'warning--double-turn-first-right--g1': icon1139,
  'warning--dual-lanes-all-directions-on-left--g1': icon1140,
  'warning--dual-lanes-all-directions-on-right--g1': icon1141,
  'warning--dual-lanes-go-straight-or-turn-left--g1': icon1142,
  'warning--dual-lanes-go-straight-or-turn-right--g1': icon1143,
  'warning--dual-lanes-left-turn--g1': icon1144,
  'warning--dual-lanes-left-turn-or-go-straight--g1': icon1145,
  'warning--dual-lanes-right-turn--g1': icon1146,
  'warning--dual-lanes-right-turn-or-go-straight--g1': icon1147,
  'warning--dual-lanes-turn-left--g1': icon1148,
  'warning--dual-lanes-turn-left-or-right--g1': icon1149,
  'warning--dual-lanes-turn-left-or-right--g2': icon1150,
  'warning--dual-lanes-turn-left-or-right--g3': icon1151,
  'warning--dual-lanes-turn-left-or-right--g4': icon1152,
  'warning--dual-lanes-turn-right--g1': icon1153,
  'warning--dual-path-cyclists-and-pedestrians--g1': icon1154,
  'warning--electricity--g1': icon1155,
  'warning--electricity--g2': icon1156,
  'warning--elephant-crossing--g1': icon1157,
  'warning--emergency-vehicles--g1': icon1158,
  'warning--emu-crossing--g1': icon1159,
  'warning--emu-crossing--g2': icon1160,
  'warning--entering-roadway-merge--g1': icon1161,
  'warning--entering-roadway-merge--g2': icon1162,
  'warning--equestrians-crossing--g1': icon1163,
  'warning--equestrians-crossing--g2': icon1164,
  'warning--expressway--g1': icon1165,
  'warning--falling-rocks-or-debris-left--g1': icon1166,
  'warning--falling-rocks-or-debris-left--g2': icon1167,
  'warning--falling-rocks-or-debris-left--g3': icon1168,
  'warning--falling-rocks-or-debris-left--g4': icon1169,
  'warning--falling-rocks-or-debris-right--g1': icon1170,
  'warning--falling-rocks-or-debris-right--g2': icon1171,
  'warning--falling-rocks-or-debris-right--g3': icon1172,
  'warning--falling-rocks-or-debris-right--g4': icon1173,
  'warning--ferry--g1': icon1174,
  'warning--flaggers-in-road--g1': icon1175,
  'warning--flaggers-in-road--g2': icon1176,
  'warning--foggy-road--g1': icon1177,
  'warning--foggy-road--g2': icon1178,
  'warning--ford--g1': icon1179,
  'warning--forest--g1': icon1180,
  'warning--fresh-oil--g1': icon1181,
  'warning--frog-crossing--g1': icon1182,
  'warning--gate--g1': icon1183,
  'warning--gate--g2': icon1184,
  'warning--gate-left--g1': icon1185,
  'warning--gate-right--g1': icon1186,
  'warning--go-left--g1': icon1187,
  'warning--go-right--g1': icon1188,
  'warning--golf-carts-crossing--g1': icon1189,
  'warning--gravel-road-surface--g1': icon1190,
  'warning--hairpin-curve-left--g1': icon1191,
  'warning--hairpin-curve-left--g2': icon1192,
  'warning--hairpin-curve-left--g3': icon1193,
  'warning--hairpin-curve-right--g1': icon1194,
  'warning--hairpin-curve-right--g3': icon1195,
  'warning--height-restriction--g2': icon1196,
  'warning--height-restriction--g3': icon1197,
  'warning--height-restriction--g4': icon1198,
  'warning--height-restriction--g5': icon1199,
  'warning--horizontal-alignment-left--g1': icon1200,
  'warning--horizontal-alignment-left--g3': icon1201,
  'warning--horizontal-alignment-right--g1': icon1202,
  'warning--horizontal-alignment-right--g3': icon1203,
  'warning--horse-crossing--g1': icon1204,
  'warning--icy-road--g1': icon1205,
  'warning--junction-with-a-side-road-acute-left--g1': icon1206,
  'warning--junction-with-a-side-road-acute-left--g2': icon1207,
  'warning--junction-with-a-side-road-acute-right--g1': icon1208,
  'warning--junction-with-a-side-road-acute-right--g2': icon1209,
  'warning--junction-with-a-side-road-perpendicular-left--g1': icon1210,
  'warning--junction-with-a-side-road-perpendicular-left--g2': icon1211,
  'warning--junction-with-a-side-road-perpendicular-left--g3': icon1212,
  'warning--junction-with-a-side-road-perpendicular-left--g4': icon1213,
  'warning--junction-with-a-side-road-perpendicular-right--g1': icon1214,
  'warning--junction-with-a-side-road-perpendicular-right--g2': icon1215,
  'warning--junction-with-a-side-road-perpendicular-right--g3': icon1216,
  'warning--junction-with-a-side-road-perpendicular-right--g4': icon1217,
  'warning--junction-with-merge-from-left--g1': icon1218,
  'warning--junction-with-merge-from-right--g1': icon1219,
  'warning--junction-with-side-roads--g1': icon1220,
  'warning--kangaloo-crossing--g1': icon1221,
  'warning--keep-distance--g1': icon1222,
  'warning--keep-left--g1': icon1223,
  'warning--keep-right--g1': icon1224,
  'warning--kiwi-crossing--g1': icon1225,
  'warning--kiwi-crossing--g2': icon1226,
  'warning--koala-crossing--g1': icon1227,
  'warning--koala-crossing--g2': icon1228,
  'warning--koala-crossing--g3': icon1229,
  'warning--koala-crossing--g4': icon1230,
  'warning--lane-closed-in-dual-lanes-left--g1': icon1231,
  'warning--lane-closed-in-dual-lanes-left--g2': icon1232,
  'warning--lane-closed-in-dual-lanes-right--g1': icon1233,
  'warning--lane-closed-in-dual-lanes-right--g2': icon1234,
  'warning--length-restriction--g1': icon1235,
  'warning--length-restriction--g2': icon1236,
  'warning--light-rail-transit-vehicles--g1': icon1237,
  'warning--limited-lighting-under-trees--g1': icon1238,
  'warning--logging-vehicles--g1': icon1239,
  'warning--loop-270-degree--g1': icon1240,
  'warning--loop-pretzel--g1': icon1241,
  'warning--loose-road-surface--g1': icon1242,
  'warning--loose-road-surface--g2': icon1243,
  'warning--loose-road-surface--g3': icon1244,
  'warning--loose-road-surface--g4': icon1245,
  'warning--low-flying-aircraft--g1': icon1246,
  'warning--low-flying-aircraft--g2': icon1247,
  'warning--low-flying-aircraft--g3': icon1248,
  'warning--low-flying-aircraft--g4': icon1249,
  'warning--low-flying-aircraft--g5': icon1250,
  'warning--low-flying-aircraft--g6': icon1251,
  'warning--low-flying-aircraft--g7': icon1252,
  'warning--low-flying-aircraft--g8': icon1253,
  'warning--low-ground-clearance--g1': icon1254,
  'warning--low-ground-clearance--g2': icon1255,
  'warning--low-ground-clearance--g3': icon1256,
  'warning--monkey-crossing--g1': icon1257,
  'warning--motorcycles-crossing--g1': icon1258,
  'warning--narrow-bridge--g1': icon1259,
  'warning--narrow-bridge--g2': icon1260,
  'warning--narrow-bridge--g3': icon1261,
  'warning--no-passing-zone--g1': icon1262,
  'warning--no-passing-zone--g2': icon1263,
  'warning--occupied-lanes--g1': icon1264,
  'warning--offset-roads--g1': icon1265,
  'warning--offset-roads--g2': icon1266,
  'warning--offset-roads--g3': icon1267,
  'warning--offset-roads--g4': icon1268,
  'warning--opening-or-swing-bridge--g1': icon1269,
  'warning--opening-or-swing-bridge--g2': icon1270,
  'warning--other-danger--g1': icon1271,
  'warning--other-danger--g2': icon1272,
  'warning--other-danger--g3': icon1273,
  'warning--panda-crossing--g1': icon1274,
  'warning--pass-left-or-right--g1': icon1275,
  'warning--pass-left-or-right--g2': icon1276,
  'warning--pass-left-or-right--g3': icon1277,
  'warning--pavement-ahead--g1': icon1278,
  'warning--pavement-ends--g1': icon1279,
  'warning--pavement-ends--g2': icon1280,
  'warning--pavement-ends--g3': icon1281,
  'warning--pavement-ends--g4': icon1282,
  'warning--pavement-ends--g5': icon1283,
  'warning--pedestrians-crossing--g1': icon1284,
  'warning--pedestrians-crossing--g4': icon1285,
  'warning--pedestrians-crossing--g5': icon1286,
  'warning--pedestrians-crossing--g6': icon1287,
  'warning--pedestrians-crossing--g7': icon1288,
  'warning--pedestrians-crossing--g8': icon1289,
  'warning--pedestrians-crossing--g9': icon1290,
  'warning--pedestrians-crossing--g10': icon1291,
  'warning--pedestrians-crossing--g11': icon1292,
  'warning--pedestrians-crossing--g12': icon1293,
  'warning--playground--g1': icon1294,
  'warning--playground--g3': icon1295,
  'warning--polar-bear-crossing--g1': icon1296,
  'warning--quay-or-river-bank--g1': icon1297,
  'warning--quay-or-river-bank--g2': icon1298,
  'warning--quay-or-river-bank--g3': icon1299,
  'warning--quay-or-river-bank--g4': icon1300,
  'warning--rabbit-crossing--g1': icon1301,
  'warning--raccoon-crossing--g1': icon1302,
  'warning--railroad-crossing--g1': icon1303,
  'warning--railroad-crossing--g2': icon1304,
  'warning--railroad-crossing--g3': icon1305,
  'warning--railroad-crossing--g4': icon1306,
  'warning--railroad-crossing-with-barriers--g1': icon1307,
  'warning--railroad-crossing-with-barriers--g2': icon1308,
  'warning--railroad-crossing-with-barriers--g3': icon1309,
  'warning--railroad-crossing-with-barriers--g4': icon1310,
  'warning--railroad-crossing-with-barriers--g5': icon1311,
  'warning--railroad-crossing-with-barriers--g6': icon1312,
  'warning--railroad-crossing-with-barriers--g7': icon1313,
  'warning--railroad-crossing-without-barriers--g1': icon1314,
  'warning--railroad-crossing-without-barriers--g2': icon1315,
  'warning--railroad-crossing-without-barriers--g3': icon1316,
  'warning--railroad-crossing-without-barriers--g4': icon1317,
  'warning--railroad-crossing-without-barriers--g5': icon1318,
  'warning--railroad-crossing-without-barriers--g6': icon1319,
  'warning--railroad-intersection--g1': icon1320,
  'warning--railroad-intersection--g2': icon1321,
  'warning--railroad-intersection--g3': icon1322,
  'warning--railroad-intersection--g4': icon1323,
  'warning--railroad-intersection--g5': icon1324,
  'warning--railroad-intersection--g6': icon1325,
  'warning--railroad-intersection--g7': icon1326,
  'warning--railroad-intersection--g8': icon1327,
  'warning--railroad-intersection--g9': icon1328,
  'warning--ramp-closed--g1': icon1329,
  'warning--reduced-maximum-speed-limit--g1': icon1330,
  'warning--reserved-lane--g1': icon1331,
  'warning--restricted-zone--g1': icon1332,
  'warning--reversible-lanes--g1': icon1333,
  'warning--reversible-lanes--g2': icon1334,
  'warning--rickshaws-crossing--g1': icon1335,
  'warning--road-blocks--g1': icon1336,
  'warning--road-bump--g1': icon1337,
  'warning--road-bump--g2': icon1338,
  'warning--road-bump--g3': icon1339,
  'warning--road-bump-with-speed-limit--g1': icon1340,
  'warning--road-closed--g3': icon1341,
  'warning--road-narrows--g1': icon1342,
  'warning--road-narrows--g2': icon1343,
  'warning--road-narrows-left--g1': icon1344,
  'warning--road-narrows-left--g2': icon1345,
  'warning--road-narrows-left-ahead--g1': icon1346,
  'warning--road-narrows-right--g1': icon1347,
  'warning--road-narrows-right--g2': icon1348,
  'warning--road-narrows-right-ahead--g1': icon1349,
  'warning--road-toll-ahead--g1': icon1350,
  'warning--road-widens--g1': icon1351,
  'warning--road-widens-left--g1': icon1352,
  'warning--road-widens-right--g1': icon1353,
  'warning--roadworks--g1': icon1354,
  'warning--roadworks--g2': icon1355,
  'warning--roadworks--g3': icon1356,
  'warning--roadworks--g5': icon1357,
  'warning--roadworks--g6': icon1358,
  'warning--roadworks--g8': icon1359,
  'warning--roadworks--g9': icon1360,
  'warning--roadworks--g10': icon1361,
  'warning--roadworks--g11': icon1362,
  'warning--roadworks-go-left-or-straight--g1': icon1363,
  'warning--roadworks-go-right-or-straight--g1': icon1364,
  'warning--roundabout--g1': icon1365,
  'warning--roundabout--g2': icon1366,
  'warning--roundabout--g3': icon1367,
  'warning--roundabout--g4': icon1368,
  'warning--roundabout--g5': icon1369,
  'warning--roundabout--g6': icon1370,
  'warning--roundabout--g7': icon1371,
  'warning--ruts--g1': icon1372,
  'warning--sand--g1': icon1373,
  'warning--sand-drift--g1': icon1374,
  'warning--school-zone--g2': icon1375,
  'warning--severe-weather--g1': icon1376,
  'warning--shared-lane-motorcycles-bicycles--g1': icon1377,
  'warning--sharp-turn--g1': icon1378,
  'warning--single-reverse-curve--g1': icon1379,
  'warning--skewed-t-roads-left--g1': icon1380,
  'warning--skewed-t-roads-left--g2': icon1381,
  'warning--skewed-t-roads-left--g3': icon1382,
  'warning--skewed-t-roads-right--g1': icon1383,
  'warning--skewed-t-roads-right--g2': icon1384,
  'warning--skewed-t-roads-right--g3': icon1385,
  'warning--skiers--g1': icon1386,
  'warning--skiers--g2': icon1387,
  'warning--skiers--g3': icon1388,
  'warning--slippery-bicycles--g1': icon1389,
  'warning--slippery-motorcycles--g1': icon1390,
  'warning--slippery-motorcycles--g2': icon1391,
  'warning--slippery-road-surface--g1': icon1392,
  'warning--slippery-road-surface--g2': icon1393,
  'warning--slow--g1': icon1394,
  'warning--snow-tractors--g1': icon1395,
  'warning--snowmobiles--g1': icon1396,
  'warning--snowmobiles--g2': icon1397,
  'warning--snowmobiles--g3': icon1398,
  'warning--snowmobiles-and-others--g1': icon1399,
  'warning--soft-road-surface--g1': icon1400,
  'warning--soft-road-surface--g2': icon1401,
  'warning--soft-shoulder--g1': icon1402,
  'warning--soft-shoulder--g2': icon1403,
  'warning--soft-shoulder--g3': icon1404,
  'warning--soft-shoulder--g4': icon1405,
  'warning--speed-camera--g1': icon1406,
  'warning--steep-ascent--g1': icon1407,
  'warning--steep-ascent--g2': icon1408,
  'warning--steep-ascent--g3': icon1409,
  'warning--steep-ascent--g4': icon1410,
  'warning--steep-ascent-and-descent--g1': icon1411,
  'warning--steep-descent--g1': icon1412,
  'warning--steep-descent--g2': icon1413,
  'warning--steep-descent--g3': icon1414,
  'warning--steep-descent--g4': icon1415,
  'warning--steep-descent--g5': icon1416,
  'warning--steep-descent--g6': icon1417,
  'warning--stop-ahead--g1': icon1418,
  'warning--stop-ahead--g3': icon1419,
  'warning--stop-ahead--g4': icon1420,
  'warning--stop-ahead--g5': icon1421,
  'warning--stop-ahead--g6': icon1422,
  'warning--t-roads--g1': icon1423,
  'warning--t-roads--g2': icon1424,
  'warning--tanks-crossing--g1': icon1425,
  'warning--tanks-crossing--g2': icon1426,
  'warning--texts--g1': icon1427,
  'warning--texts--g2': icon1428,
  'warning--texts--g3': icon1429,
  'warning--towing--g1': icon1430,
  'warning--tractors--g1': icon1431,
  'warning--tractors--g2': icon1432,
  'warning--tractors--g3': icon1433,
  'warning--tractors--g4': icon1434,
  'warning--tractors--g5': icon1435,
  'warning--tractors--g6': icon1436,
  'warning--tractors--g7': icon1437,
  'warning--traffic-merges-at-signalized-intersections--g1': icon1438,
  'warning--traffic-merges-left--g1': icon1439,
  'warning--traffic-merges-left--g2': icon1440,
  'warning--traffic-merges-left--g3': icon1441,
  'warning--traffic-merges-left--g4': icon1442,
  'warning--traffic-merges-left-and-right--g1': icon1443,
  'warning--traffic-merges-left-buses--g1': icon1444,
  'warning--traffic-merges-right--g1': icon1445,
  'warning--traffic-merges-right--g2': icon1446,
  'warning--traffic-merges-right--g3': icon1447,
  'warning--traffic-merges-right-buses--g1': icon1448,
  'warning--traffic-queues-likely--g1': icon1449,
  'warning--traffic-queues-likely--g2': icon1450,
  'warning--traffic-queues-likely--g3': icon1451,
  'warning--traffic-queues-likely--g4': icon1452,
  'warning--traffic-queues-likely--g5': icon1453,
  'warning--traffic-signals--g1': icon1454,
  'warning--traffic-signals--g2': icon1455,
  'warning--traffic-signals--g3': icon1456,
  'warning--traffic-signals--g4': icon1457,
  'warning--traffic-signals--g5': icon1458,
  'warning--traffic-signals--g6': icon1459,
  'warning--traffic-slow--g1': icon1460,
  'warning--trail-crossing--g1': icon1461,
  'warning--trail-crossing--g2': icon1462,
  'warning--trail-crossing--g3': icon1463,
  'warning--trail-crossing--g4': icon1464,
  'warning--trail-crossing--g5': icon1465,
  'warning--trail-crossing--g6': icon1466,
  'warning--trams-crossing--g1': icon1467,
  'warning--trams-crossing--g2': icon1468,
  'warning--triple-curve-left--g1': icon1469,
  'warning--triple-curve-right--g1': icon1470,
  'warning--triple-lanes-left-turn--g1': icon1471,
  'warning--triple-lanes-left-turn-or-go-straight--g1': icon1472,
  'warning--triple-lanes-right-turn--g1': icon1473,
  'warning--triple-lanes-right-turn-or-go-straight--g1': icon1474,
  'warning--triple-lanes-with-directions--g1': icon1475,
  'warning--triple-reverse-curve-left--g1': icon1476,
  'warning--triple-reverse-curve-right--g1': icon1477,
  'warning--trucks-crossing--g1': icon1478,
  'warning--trucks-crossing--g2': icon1479,
  'warning--trucks-rollover--g1': icon1480,
  'warning--trucks-rollover--g2': icon1481,
  'warning--trucks-rollover--g3': icon1482,
  'warning--trucks-rollover--g4': icon1483,
  'warning--trucks-rollover--g5': icon1484,
  'warning--tunnel--g1': icon1485,
  'warning--tunnel--g2': icon1486,
  'warning--tunnel--g3': icon1487,
  'warning--tunnel--g4': icon1488,
  'warning--tunnel--g5': icon1489,
  'warning--tunnel--g6': icon1490,
  'warning--tunnel--g7': icon1491,
  'warning--turn-left--g1': icon1492,
  'warning--turn-left--g2': icon1493,
  'warning--turn-left--g3': icon1494,
  'warning--turn-left-or-right--g1': icon1495,
  'warning--turn-right--g1': icon1496,
  'warning--turn-right--g2': icon1497,
  'warning--turn-right--g3': icon1498,
  'warning--two-way-traffic--g1': icon1499,
  'warning--two-way-traffic--g2': icon1500,
  'warning--two-way-traffic--g3': icon1501,
  'warning--two-way-traffic--g4': icon1502,
  'warning--two-way-traffic--g5': icon1503,
  'warning--two-way-traffic--g6': icon1504,
  'warning--u-turn--g1': icon1505,
  'warning--u-turn--g2': icon1506,
  'warning--uneven-road--g1': icon1507,
  'warning--uneven-road--g2': icon1508,
  'warning--uneven-roads-ahead--g1': icon1509,
  'warning--vehicles-and-others--g1': icon1510,
  'warning--vehicles-crossing--g1': icon1511,
  'warning--village--g1': icon1512,
  'warning--weight-limit--g5': icon1513,
  'warning--weight-limit-per-tandem-axle--g1': icon1514,
  'warning--width-restriction--g1': icon1515,
  'warning--width-restriction--g2': icon1516,
  'warning--width-restriction--g3': icon1517,
  'warning--width-restriction--g4': icon1518,
  'warning--wild-animals--g1': icon1519,
  'warning--wild-animals--g2': icon1520,
  'warning--wild-animals--g3': icon1521,
  'warning--wild-animals--g4': icon1522,
  'warning--wild-animals--g5': icon1523,
  'warning--wild-animals--g6': icon1524,
  'warning--wild-animals--g7': icon1525,
  'warning--wild-animals--g8': icon1526,
  'warning--wind--g1': icon1527,
  'warning--winding-road--g1': icon1528,
  'warning--winding-road-first-left--g1': icon1529,
  'warning--winding-road-first-left--g2': icon1530,
  'warning--winding-road-first-left--g3': icon1531,
  'warning--winding-road-first-right--g1': icon1532,
  'warning--winding-road-first-right--g2': icon1533,
  'warning--winding-road-first-right--g3': icon1534,
  'warning--winding-road-first-right--g4': icon1535,
  'warning--winding-road-to-left--g1': icon1536,
  'warning--winding-road-to-right--g1': icon1537,
  'warning--wombat-crossing--g1': icon1538,
  'warning--y-roads--g1': icon1539,
  'warning--y-roads--g2': icon1540,
  'warning--yield-ahead--g1': icon1541,
  'warning--yield-ahead--g3': icon1542,
};

export default textures;